import * as tslib_1 from "tslib";
import { AfterViewInit, ChangeDetectorRef, ElementRef, ErrorHandler, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar, MatTab, MatTabGroup } from '@angular/material';
import { Meta, Title } from '@angular/platform-browser';
import { debounceTime, filter, tap } from 'rxjs/operators';
import * as debounce from 'lodash/debounce';
import { NEIGHBORSTATES } from '../../util/neighbor-states';
import { storageAvailable } from '../../util/helpers';
import { ResultsMapComponent } from '../results-map/results-map.component';
import { SearchFormType } from '../models/search-form-type.model';
import { SearchQuery } from '../models/search-query.model';
import { State } from '../../shared/state-view/state.model';
import { QueryValidationReason } from '../models/query-validation-result.model';
import { FilterKeys } from '../filters/filters';
import { SearchFormComponent } from '../search-form/search-form.component';
import { AirportService, MAX_BBOX_AREA } from '../../airport/airport.service';
import { GoogleService } from '../../google/google.service';
import { AirportResultsListingComponent } from '../airport-results-listing/airport-results-listing.component';
import { ActivityResultsListingComponent } from '../activity-results-listing/activity-results-listing.component';
import { EventResultsListingComponent } from '../event-results-listing/event-results-listing.component';
import { environment } from '../../../environments/environment';
import { BusinessFuel, FuelType } from '../../business/models/business-fuel.model';
import { GlobalSettingsService } from '../../shared/services/global-settings.service';
import { AviationEventType } from '../../shared/models/aviation-event.model';
import { AviationEventsService } from '../../shared/services/aviation-events.service';
import { AviationEventFiltersService } from '../../shared/services/aviation-event-filters.service';
import { FlyingClubsService } from '../../shared/services/flying-clubs.service';
import { FlyingClubFinderFiltersService } from '../../shared/services/flying-club-finder-filters.service';
import { FLYING_CLUB_EQUITY_TAG, FLYING_CLUB_NON_EQUITY_TAG, FLYING_CLUB_HYBRID_EQUITY_TAG } from '../../shared/models/flying-club-finder-filter.model';
// tslint:disable-next-line:max-line-length
import { FlyingClubFinderResultsListingComponent } from '../flying-club-finder-results-listing/flying-club-finder-results-listing.component';
import { FlightSchoolsService } from '../../shared/services/flight-schools.service';
import { FlightSchoolFinderFiltersService } from '../../shared/services/flight-school-finder-filters.service';
// tslint:disable-next-line:max-line-length
import { FlightSchoolFinderResultsListingComponent } from '../flight-school-finder-results-listing/flight-school-finder-results-listing.component';
import { UniversitiesService } from '../../shared/services/universities.service';
import { UniversityFinderFiltersService } from '../../shared/services/university-finder-filters.service';
// tslint:disable-next-line:max-line-length
import { UniversityFinderResultsListingComponent } from '../university-finder-results-listing/university-finder-results-listing.component';
import { FbosService } from '../../shared/services/fbos.service';
import { FboFinderFiltersService } from '../../shared/services/fbo-finder-filters.service';
// tslint:disable-next-line:max-line-length
import { FboFinderResultsListingComponent } from '../fbo-finder-results-listing/fbo-finder-results-listing.component';
import { ServiceRepairsService } from '../../shared/services/service-repairs.service';
import { ServiceRepairFinderFiltersService } from '../../shared/services/service-repair-finder-filters.service';
// tslint:disable-next-line:max-line-length
import { ServiceRepairFinderResultsListingComponent } from '../service-repair-finder-results-listing/service-repair-finder-results-listing.component';
import { RentalSalesService } from '../../shared/services/rental-sales.service';
import { RentalSalesFinderFiltersService } from '../../shared/services/rental-sales-finder-filters.service';
// tslint:disable-next-line:max-line-length
import { RentalSalesFinderResultsListingComponent } from '../rental-sales-finder-results-listing/rental-sales-finder-results-listing.component';
import * as moment from 'moment-timezone';
import { AnalyticsService } from '../../airport/service/google-analytics-4.service';
import { AuthService } from '../../auth/auth/auth.service';
/**
 * Period of time to wait (in milliseconds) before issuing a new bounding box search after panning or zooming
 * the map.
 */
var SEARCH_DEBOUNCE_TIME = 500;
/**
 * Max viewport bounding-box area (square degrees) for the University Finder before the "zoom in to update
 * results" message blocks a pan/zoom search — wide enough to cover the entire continental US in one view.
 * Universities are few enough nationwide (~300) that a user should be able to see them all without zooming in,
 * unlike the other map-searched finders which use the tighter {@link MAX_BBOX_AREA}.
 */
var UNIVERSITY_MAX_BBOX_AREA = 3000;
var SearchPageComponent = /** @class */ (function () {
    function SearchPageComponent(_route, _router, _meta, _title, _airportService, _google, _cdref, _errorHandler, _globalSettingsService, _aviationEventsService, _aviationEventFiltersService, _flyingClubsService, _flyingClubFinderFiltersService, _flightSchoolsService, _flightSchoolFinderFiltersService, _universitiesService, _universityFinderFiltersService, _fbosService, _fboFinderFiltersService, _serviceRepairsService, _serviceRepairFinderFiltersService, _rentalSalesService, _rentalSalesFinderFiltersService, _snackBar, _analyticsService, _auth) {
        this._route = _route;
        this._router = _router;
        this._meta = _meta;
        this._title = _title;
        this._airportService = _airportService;
        this._google = _google;
        this._cdref = _cdref;
        this._errorHandler = _errorHandler;
        this._globalSettingsService = _globalSettingsService;
        this._aviationEventsService = _aviationEventsService;
        this._aviationEventFiltersService = _aviationEventFiltersService;
        this._flyingClubsService = _flyingClubsService;
        this._flyingClubFinderFiltersService = _flyingClubFinderFiltersService;
        this._flightSchoolsService = _flightSchoolsService;
        this._flightSchoolFinderFiltersService = _flightSchoolFinderFiltersService;
        this._universitiesService = _universitiesService;
        this._universityFinderFiltersService = _universityFinderFiltersService;
        this._fbosService = _fbosService;
        this._fboFinderFiltersService = _fboFinderFiltersService;
        this._serviceRepairsService = _serviceRepairsService;
        this._serviceRepairFinderFiltersService = _serviceRepairFinderFiltersService;
        this._rentalSalesService = _rentalSalesService;
        this._rentalSalesFinderFiltersService = _rentalSalesFinderFiltersService;
        this._snackBar = _snackBar;
        this._analyticsService = _analyticsService;
        this._auth = _auth;
        this.query = new SearchQuery();
        this.sidebarOpened = true;
        this.airports = [];
        this.activities = [];
        this.aviationEvents = [];
        this.airportState = State.Empty;
        this.activityState = State.Empty;
        this.aviationEventsState = State.Empty;
        this.pageIndex = 0;
        this.pageSize = 10;
        this.filteredAirports = [];
        this.filteredAviationEvents = [];
        this.declutteredAirports = [];
        this.locationState = State.Empty;
        this.pauseBounds = false;
        this.mapMessage = null;
        this._selectedAirportId = null;
        this.$sidebar = null;
        this.backToSearchVisible = false;
        this._handler = null;
        this.fuelType = FuelType._100LL;
        this.NEIGHBORSTATES = NEIGHBORSTATES;
        this.exceedsAirportBounds = false;
        this.eventPageIndex = 0;
        this.eventPageSize = 25;
        this.flyingClubs = [];
        this.filteredFlyingClubs = [];
        this.flyingClubsState = State.Empty;
        this.flyingClubPageIndex = 0;
        this.flyingClubPageSize = 25;
        this.flightSchools = [];
        this.filteredFlightSchools = [];
        this.flightSchoolsState = State.Empty;
        this.flightSchoolPageIndex = 0;
        this.flightSchoolPageSize = 25;
        this.universities = [];
        this.filteredUniversities = [];
        this.universitiesState = State.Empty;
        this.universityPageIndex = 0;
        this.universityPageSize = 25;
        this.fbos = [];
        this.filteredFbos = [];
        this.fbosState = State.Empty;
        this.fboPageIndex = 0;
        this.fboPageSize = 25;
        this.serviceRepairs = [];
        this.filteredServiceRepairs = [];
        this.serviceRepairsState = State.Empty;
        this.serviceRepairPageIndex = 0;
        this.serviceRepairPageSize = 25;
        this.rentalSales = [];
        this.filteredRentalSales = [];
        this.rentalSalesState = State.Empty;
        this.rentalSalesPageIndex = 0;
        this.rentalSalesPageSize = 25;
        /**
         * True only during the initial view setup, while the search type's tab is being selected programmatically.
         * Setting tabGroup.selectedIndex fires (selectedTabChange) → onSelectTab, which would run the finder search
         * a second time (the setTimeout in ngAfterViewInit is the canonical initial search). This flag makes
         * onSelectTab skip that redundant initial search so the finder endpoint isn't hit twice on page load.
         */
        this._suppressInitialTabSearch = false;
        /**
         * The state/province (e.g. "CA") of the current state search, preserved so switching to a different finder
         * tab can re-run the search for that state. Each per-tab finder search nulls this.query.state after using it
         * (see the state branches in searchFbos / searchFlyingClubs / ...), so without this the state would be lost
         * the moment you switch finders and the new tab would have no query — showing an empty map and the
         * "Please enter a search query" placeholder. Captured whenever a fresh query is established (deserializeQuery
         * on load, search() on form submit); null for any non-state search so it never hijacks a name/location search.
         */
        this._finderStateProvince = null;
        this._title.setTitle("Airport Search - " + environment.appName);
        this._meta.removeTag('name="description"');
    }
    Object.defineProperty(SearchPageComponent.prototype, "searchType", {
        get: function () {
            var tab = this._getSelectedTab();
            if (tab === this.activitiesTab) {
                return SearchFormType.Activities;
            }
            else if (tab === this.aviationEventsTab) {
                return SearchFormType.AviationEvents;
            }
            else if (tab === this.flyingClubsTab) {
                return SearchFormType.FlyingClubs;
            }
            else if (tab === this.flightSchoolsTab) {
                return SearchFormType.FlightSchools;
            }
            else if (tab === this.universitiesTab) {
                return SearchFormType.Universities;
            }
            else if (tab === this.fbosTab) {
                return SearchFormType.Fbos;
            }
            else if (tab === this.serviceRepairsTab) {
                return SearchFormType.ServiceRepair;
            }
            else if (tab === this.rentalSalesTab) {
                return SearchFormType.RentalSales;
            }
            else {
                if (this.query && this.query.type && this.query.type === SearchFormType.FuelPrice) {
                    return SearchFormType.FuelPrice;
                }
                else {
                    return SearchFormType.Airports;
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SearchPageComponent.prototype, "toggleTooltip", {
        get: function () {
            return this.sidebarOpened ? 'Collapse sidebar' : 'Expand sidebar';
        },
        enumerable: true,
        configurable: true
    });
    SearchPageComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._initBoundsListener();
        this.fuelTypeSubscription = this._globalSettingsService.fuelType.subscribe(function (fuel) {
            _this.fuelType = BusinessFuel.parseFuelType(fuel);
        });
        this.aviationEventFilterSubscription = this._aviationEventFiltersService.aviationEventFilter.subscribe(function (ae) {
            _this.aviationEventFilter = ae;
        });
        this.flyingClubFinderFilterSubscription = this._flyingClubFinderFiltersService.flyingClubFinderFilter.subscribe(function (f) {
            _this.flyingClubFinderFilter = f;
        });
        this.flightSchoolFinderFilterSubscription = this._flightSchoolFinderFiltersService.flightSchoolFinderFilter.subscribe(function (f) {
            _this.flightSchoolFinderFilter = f;
        });
        this.universityFinderFilterSubscription = this._universityFinderFiltersService.universityFinderFilter.subscribe(function (f) {
            _this.universityFinderFilter = f;
        });
        this.fboFinderFilterSubscription = this._fboFinderFiltersService.fboFinderFilter.subscribe(function (f) {
            _this.fboFinderFilter = f;
        });
        this.serviceRepairFinderFilterSubscription = this._serviceRepairFinderFiltersService.serviceRepairFinderFilter.subscribe(function (f) {
            _this.serviceRepairFinderFilter = f;
        });
        this.rentalSalesFinderFilterSubscription = this._rentalSalesFinderFiltersService.rentalSalesFinderFilter.subscribe(function (f) {
            _this.rentalSalesFinderFilter = f;
        });
        this._analyticsService.pageView('airport_search', 'Airport/Event Search');
        if (this._auth.authenticated && this._auth.endUser) {
            this._analyticsService.trackEvent('airport_search_loggedin', this._auth.recid, this._auth.recid);
        }
        else {
            this._analyticsService.trackEvent('airport_search_loggedout', '', '');
        }
    };
    SearchPageComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        // Set the initial tab based on search type. Suppress onSelectTab's search while we do this — the
        // setTimeout below performs the canonical initial search.
        this._suppressInitialTabSearch = true;
        var query = SearchQuery.decode(this._route.snapshot.queryParamMap);
        if (query.type === SearchFormType.Activities) {
            this.tabGroup.selectedIndex = 1;
        }
        if (query.type === SearchFormType.AviationEvents) {
            this.tabGroup.selectedIndex = 2;
            this._aviationEventFiltersService.updateAviationEventFilters(query.aviationEventsFilter);
        }
        if (query.type === SearchFormType.FlyingClubs) {
            this.tabGroup.selectedIndex = 3;
            this._flyingClubFinderFiltersService.updateFlyingClubFinderFilters(query.flyingClubFinderFilter);
        }
        if (query.type === SearchFormType.FlightSchools) {
            this.tabGroup.selectedIndex = 4;
            this._flightSchoolFinderFiltersService.updateFlightSchoolFinderFilters(query.flightSchoolFinderFilter);
        }
        if (query.type === SearchFormType.Universities) {
            this.tabGroup.selectedIndex = 5;
            this._universityFinderFiltersService.updateUniversityFinderFilters(query.universityFinderFilter);
        }
        if (query.type === SearchFormType.Fbos) {
            this.tabGroup.selectedIndex = 6;
            this._fboFinderFiltersService.updateFboFinderFilters(query.fboFinderFilter);
        }
        if (query.type === SearchFormType.ServiceRepair) {
            this.tabGroup.selectedIndex = 7;
            this._serviceRepairFinderFiltersService.updateServiceRepairFinderFilters(query.serviceRepairFinderFilter);
        }
        if (query.type === SearchFormType.RentalSales) {
            this.tabGroup.selectedIndex = 8;
            this._rentalSalesFinderFiltersService.updateRentalSalesFinderFilters(query.rentalSalesFinderFilter);
        }
        // Wrapped in setTimeout to avoid triggering change detection error
        // ("Expression has changed after it was checked").
        setTimeout(function () {
            // Store the initially selected tab.
            _this.selectedTab = _this._getSelectedTab();
            // Deserialize the search query from the URL
            _this.deserializeQuery();
            // Perform the initial search, but only if the selected tab is the default one. Otherwise,
            // rely on the onSelectTab event handler to perform the initial search.
            _this.searchAirports(false);
            if (_this.tabGroup.selectedIndex === 1) {
                _this.searchActivities();
            }
            if (_this.tabGroup.selectedIndex === 2) {
                _this.searchEvents(false);
            }
            if (_this.tabGroup.selectedIndex === 3) {
                _this.searchFlyingClubs();
            }
            if (_this.tabGroup.selectedIndex === 4) {
                _this.searchFlightSchools();
            }
            if (_this.tabGroup.selectedIndex === 5) {
                _this.searchUniversities();
            }
            if (_this.tabGroup.selectedIndex === 6) {
                _this.searchFbos();
            }
            if (_this.tabGroup.selectedIndex === 7) {
                _this.searchServiceRepairs();
            }
            if (_this.tabGroup.selectedIndex === 8) {
                _this.searchRentalSales();
            }
            // Initial searches done; re-enable onSelectTab's search for subsequent user-driven tab changes.
            _this._suppressInitialTabSearch = false;
        }, 0);
        // Initialize page resize/scroll listener, which updates the visibility of a "Back to Search" button that
        // allows getting back to the search form. This is primarily useful on mobile, where a user might zoom in
        // and scroll the page into the map - at which point, scrolling back is not possible since swiping results
        // in panning the map instead of scrolling.
        // @ts-ignore
        this.$sidebar = $('.search-page__sidebar');
        this._handler = debounce(this.updateBackToSearch.bind(this), 300);
        setTimeout(function () { return _this.updateBackToSearch(); }, 300);
        // @ts-ignore
        $(window).on('resize scroll', this._handler);
    };
    SearchPageComponent.prototype.ngOnDestroy = function () {
        if (this._handler) {
            // @ts-ignore
            $(window).off('resize scroll', this._handler);
        }
        this.aviationEventFilterSubscription.unsubscribe();
        if (this.flyingClubFinderFilterSubscription) {
            this.flyingClubFinderFilterSubscription.unsubscribe();
        }
        if (this.flightSchoolFinderFilterSubscription) {
            this.flightSchoolFinderFilterSubscription.unsubscribe();
        }
        if (this.universityFinderFilterSubscription) {
            this.universityFinderFilterSubscription.unsubscribe();
        }
        if (this.fboFinderFilterSubscription) {
            this.fboFinderFilterSubscription.unsubscribe();
        }
        if (this.serviceRepairFinderFilterSubscription) {
            this.serviceRepairFinderFilterSubscription.unsubscribe();
        }
        if (this.rentalSalesFinderFilterSubscription) {
            this.rentalSalesFinderFilterSubscription.unsubscribe();
        }
    };
    SearchPageComponent.prototype.onSelectTab = function (event) {
        this.mapMessage = null;
        this.selectedTab = event.tab;
        // During initial view setup the tab is selected programmatically; the ngAfterViewInit setTimeout performs
        // the initial search, so skip here to avoid firing the (possibly slow) finder search twice on page load.
        if (this._suppressInitialTabSearch) {
            return;
        }
        this.serializeQuery();
        if (this.selectedTab === this.airportsTab) {
            this.activities = [];
            this.aviationEvents = [];
            this.filteredAviationEvents = [];
            this.searchAirports();
            this.onFiltersChanged();
        }
        // Reload airports (if not already loaded), regardless of which tab is open.
        if (this.airportState === State.Empty || this.airportState === State.Error) {
            this.searchAirports();
            this.onFiltersChanged();
        }
        // Reload activities (if not already loaded), but only if the activities tab is open.
        if (this.selectedTab === this.activitiesTab) {
            this.aviationEvents = [];
            this.filteredAviationEvents = [];
            this.searchActivities();
            this.onFiltersChanged();
        }
        // Reload aviationEvents (if not already loaded), but only if the events tab is open.
        if (this.selectedTab === this.aviationEventsTab) {
            this.activities = [];
            this.searchEvents();
            this.onFiltersChanged();
        }
        // Reload flying clubs, but only if the flying clubs tab is open.
        if (this.selectedTab === this.flyingClubsTab) {
            this.activities = [];
            this.aviationEvents = [];
            this.filteredAviationEvents = [];
            this.searchFlyingClubs();
        }
        // Reload flight schools, but only if the flight schools tab is open.
        if (this.selectedTab === this.flightSchoolsTab) {
            this.activities = [];
            this.aviationEvents = [];
            this.filteredAviationEvents = [];
            this.searchFlightSchools();
        }
        // Reload universities, but only if the universities tab is open.
        if (this.selectedTab === this.universitiesTab) {
            this.activities = [];
            this.aviationEvents = [];
            this.filteredAviationEvents = [];
            this.searchUniversities();
        }
        // Reload FBOs, but only if the businesses tab is open.
        if (this.selectedTab === this.fbosTab) {
            this.activities = [];
            this.aviationEvents = [];
            this.filteredAviationEvents = [];
            this.searchFbos();
        }
        // Reload service/repair businesses, but only if the service/repair tab is open.
        if (this.selectedTab === this.serviceRepairsTab) {
            this.activities = [];
            this.aviationEvents = [];
            this.filteredAviationEvents = [];
            this.searchServiceRepairs();
        }
        // Reload rentals/sales businesses, but only if the rentals/sales tab is open.
        if (this.selectedTab === this.rentalSalesTab) {
            this.activities = [];
            this.aviationEvents = [];
            this.filteredAviationEvents = [];
            this.searchRentalSales();
        }
    };
    SearchPageComponent.prototype._getSelectedTab = function () {
        var _this = this;
        if (!this.tabGroup._tabs) {
            return null;
        }
        return this.tabGroup._tabs
            .toArray()
            .find(function (tab, i) { return i === _this.tabGroup.selectedIndex; });
    };
    /**
     * Returns the minimum difference in the latitude or longitude of either corner of the viewport before considering the
     * new viewport to be different from the previous and issuing a new search. This is based on the previous viewport,
     * and is dependent on the scale (a difference of 0.1 degrees may be negligible when zoomed out, but significant
     * when zoomed in, so we cannot use a constant value).
     * @param bounds {BoundingBox} Viewport bounding box to use as the basis for calculating the epsilon value
     * @returns {number} Epsilon value
     */
    SearchPageComponent.prototype.getBoundingBoxEpsilon = function (bounds) {
        return 0.05 * Math.min(Math.abs(bounds.ne.lat - bounds.sw.lat), Math.abs(bounds.ne.lon - bounds.sw.lon));
    };
    Object.defineProperty(SearchPageComponent.prototype, "pagedAirports", {
        get: function () {
            if (!this.filteredAirports) {
                return [];
            }
            var start = this.pageIndex * this.pageSize;
            return this.filteredAirports.slice(start, start + this.pageSize);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SearchPageComponent.prototype, "pagedAviationEvents", {
        get: function () {
            if (!this.filteredAviationEvents) {
                return [];
            }
            var start = this.eventPageIndex * this.eventPageSize;
            return this.filteredAviationEvents.slice(start, start + this.eventPageSize);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SearchPageComponent.prototype, "pagedFlyingClubs", {
        get: function () {
            if (!this.filteredFlyingClubs) {
                return [];
            }
            var start = this.flyingClubPageIndex * this.flyingClubPageSize;
            return this.filteredFlyingClubs.slice(start, start + this.flyingClubPageSize);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SearchPageComponent.prototype, "pagedFlightSchools", {
        get: function () {
            if (!this.filteredFlightSchools) {
                return [];
            }
            var start = this.flightSchoolPageIndex * this.flightSchoolPageSize;
            return this.filteredFlightSchools.slice(start, start + this.flightSchoolPageSize);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SearchPageComponent.prototype, "pagedUniversities", {
        get: function () {
            if (!this.filteredUniversities) {
                return [];
            }
            var start = this.universityPageIndex * this.universityPageSize;
            return this.filteredUniversities.slice(start, start + this.universityPageSize);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SearchPageComponent.prototype, "pagedFbos", {
        get: function () {
            if (!this.filteredFbos) {
                return [];
            }
            var start = this.fboPageIndex * this.fboPageSize;
            return this.filteredFbos.slice(start, start + this.fboPageSize);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SearchPageComponent.prototype, "pagedServiceRepairs", {
        get: function () {
            if (!this.filteredServiceRepairs) {
                return [];
            }
            var start = this.serviceRepairPageIndex * this.serviceRepairPageSize;
            return this.filteredServiceRepairs.slice(start, start + this.serviceRepairPageSize);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SearchPageComponent.prototype, "pagedRentalSales", {
        get: function () {
            if (!this.filteredRentalSales) {
                return [];
            }
            var start = this.rentalSalesPageIndex * this.rentalSalesPageSize;
            return this.filteredRentalSales.slice(start, start + this.rentalSalesPageSize);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SearchPageComponent.prototype, "includePrivate", {
        get: function () {
            if (!this.query) {
                return false;
            }
            var f = this.query.getFilter(FilterKeys.PublicUse);
            return !f.enabled;
        },
        enumerable: true,
        configurable: true
    });
    SearchPageComponent.prototype.search = function (keepPriceSliderState) {
        // Preserve the state search for finder tab-switching (see _finderStateProvince). Reflects the current
        // query's state, or null for a non-state search so a stale state can't hijack a later name/location search.
        this._finderStateProvince = this.query.state || null;
        /** This forces all state queries to search by airport and switches back to the airport tab */
        if (this.query.state && (this._getSelectedTab() === this.activitiesTab || this._getSelectedTab() === this.aviationEventsTab)) {
            this.tabGroup.selectedIndex = 0;
        }
        if (!this.exceedsAirportBounds && this.selectedTab !== this.flyingClubsTab && this.selectedTab !== this.flightSchoolsTab &&
            this.selectedTab !== this.universitiesTab && this.selectedTab !== this.fbosTab && this.selectedTab !== this.serviceRepairsTab &&
            this.selectedTab !== this.rentalSalesTab &&
            (this.selectedTab !== this.aviationEventsTab || this.eventsResultsListing.showAirports)) {
            this.searchAirports(keepPriceSliderState);
        }
        if (this.query.type === SearchFormType.Activities) {
            this.searchActivities();
        }
        if (this.query.type === SearchFormType.AviationEvents) {
            this.searchEvents(keepPriceSliderState);
        }
        if (this.query.type === SearchFormType.FlyingClubs) {
            this.searchFlyingClubs();
        }
        if (this.query.type === SearchFormType.FlightSchools) {
            this.searchFlightSchools();
        }
        if (this.query.type === SearchFormType.Universities) {
            this.searchUniversities();
        }
        if (this.query.type === SearchFormType.Fbos) {
            this.searchFbos();
        }
        if (this.query.type === SearchFormType.ServiceRepair) {
            this.searchServiceRepairs();
        }
        if (this.query.type === SearchFormType.RentalSales) {
            this.searchRentalSales();
        }
    };
    SearchPageComponent.prototype.searchAirports = function (keepPriceSliderState) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var validationResult, _a, _b, _c, e_1, _d, e_2;
            return tslib_1.__generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _e.trys.push([0, 15, , 16]);
                        validationResult = this.query.validate();
                        if (!validationResult.valid) return [3 /*break*/, 13];
                        this.airportState = State.Loading;
                        this.form.disableForm();
                        this.serializeQuery();
                        if (!this.query.term) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this._airportService.getAirportsBySearchTerm(this.query.term, this.includePrivate)];
                    case 1:
                        _a.airports = _e.sent();
                        return [3 /*break*/, 12];
                    case 2:
                        if (!(this.query.location && this.query.radius)) return [3 /*break*/, 4];
                        _b = this;
                        return [4 /*yield*/, this._airportService.getAirportsByLatLon(this.query.location, this.query.radius, this.includePrivate)];
                    case 3:
                        _b.airports = _e.sent();
                        return [3 /*break*/, 12];
                    case 4:
                        if (!this.query.bounds) return [3 /*break*/, 9];
                        _e.label = 5;
                    case 5:
                        _e.trys.push([5, 7, , 8]);
                        _c = this;
                        return [4 /*yield*/, this._airportService.getAirportsByBoundingBox(this.query.bounds, this.includePrivate)];
                    case 6:
                        _c.airports = _e.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        e_1 = _e.sent();
                        if (e_1.message.includes('Bounding box area')) {
                            this.mapMessage = 'Zoom in to update results';
                        }
                        else {
                            throw e_1;
                        }
                        return [3 /*break*/, 8];
                    case 8: return [3 /*break*/, 12];
                    case 9:
                        if (!this.query.state) return [3 /*break*/, 11];
                        _d = this;
                        return [4 /*yield*/, this._airportService.getAirportsByState(this.query.state, this.includePrivate)];
                    case 10:
                        _d.airports = _e.sent();
                        this.activities = [];
                        this.query.state = null;
                        return [3 /*break*/, 12];
                    case 11:
                        // Events and the business finders (Flying Clubs / Flight Schools / Universities / FBOs) can be
                        // searched with no airport-usable base param — e.g. by name alone — which makes query.validate()
                        // pass even though there is nothing to search airports by. In that case there simply are no
                        // airports to show (rather than an error). Airport-type searches still require a base param.
                        if (this.query.type === SearchFormType.AviationEvents
                            || this.query.type === SearchFormType.FlyingClubs
                            || this.query.type === SearchFormType.FlightSchools
                            || this.query.type === SearchFormType.Universities
                            || this.query.type === SearchFormType.Fbos
                            || this.query.type === SearchFormType.ServiceRepair
                            || this.query.type === SearchFormType.RentalSales) {
                            this.airports = [];
                        }
                        else {
                            throw new Error('Either a search term, a location and radius, or a bounding box is required to search airports.');
                        }
                        _e.label = 12;
                    case 12:
                        this.filteredAirports = this.query.execute(this.airports);
                        this._restoreSelectedAirport();
                        this.airportState = State.Content;
                        this.form.enableForm();
                        if (!this.query.bounds) {
                            this._updateBounds();
                        }
                        this.onFiltersChanged(keepPriceSliderState);
                        this.errorMessage = null;
                        return [3 /*break*/, 14];
                    case 13:
                        if (validationResult.reason === QueryValidationReason.MISSING_BASE_PARAMS) {
                            this.airportState = State.Empty;
                            return [2 /*return*/];
                        }
                        console.warn('Invalid search query validation result:', validationResult, 'Query:', this.query);
                        this.errorMessage = validationResult.message;
                        this.airportState = State.Error;
                        _e.label = 14;
                    case 14: return [3 /*break*/, 16];
                    case 15:
                        e_2 = _e.sent();
                        this._errorHandler.handleError(e_2);
                        this.airports = [];
                        this.filteredAirports = [];
                        this.form.enableForm();
                        this.errorMessage = null;
                        this.airportState = State.Error;
                        return [3 /*break*/, 16];
                    case 16: return [2 /*return*/];
                }
            });
        });
    };
    SearchPageComponent.prototype.searchActivities = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var validationResult, result, e_3;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 8, , 9]);
                        validationResult = this.query.validate();
                        if (!validationResult.valid) return [3 /*break*/, 6];
                        if (!this.query.activity) {
                            this.activityState = State.Empty;
                            return [2 /*return*/];
                        }
                        this.activityState = State.Loading;
                        this.form.disableForm();
                        this.serializeQuery();
                        result = void 0;
                        if (!(this.query.location && this.query.radius)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._google.searchActivitiesByLatLon(this.query.activity, this.query.location, this.query.radius)];
                    case 1:
                        result = _a.sent();
                        return [3 /*break*/, 5];
                    case 2:
                        if (!this.query.bounds) return [3 /*break*/, 4];
                        return [4 /*yield*/, this._google.searchActivitiesByBoundingBox(this.query.activity, this.query.bounds)];
                    case 3:
                        result = _a.sent();
                        return [3 /*break*/, 5];
                    case 4: throw new Error('Either a location and radius or a bounding box is required to search activities');
                    case 5:
                        this.activities = result.places;
                        this.activityState = State.Content;
                        this.form.enableForm();
                        if (!this.query.bounds) {
                            this._updateBounds();
                        }
                        this.errorMessage = null;
                        return [3 /*break*/, 7];
                    case 6:
                        if (validationResult.reason === QueryValidationReason.MISSING_BASE_PARAMS) {
                            this.activityState = State.Empty;
                            return [2 /*return*/];
                        }
                        console.warn('Invalid search query validation result:', validationResult, 'Query:', this.query);
                        this.errorMessage = validationResult.message;
                        this.activityState = State.Error;
                        _a.label = 7;
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        e_3 = _a.sent();
                        this._errorHandler.handleError(e_3);
                        this.activities = [];
                        this.form.enableForm();
                        this.errorMessage = null;
                        this.activityState = State.Error;
                        return [3 /*break*/, 9];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    SearchPageComponent.prototype.onAviationEventsFiltersChanged = function () {
        this.serializeQuery();
        this.filteredAviationEvents = this.filterAviationEvents(this.aviationEvents);
    };
    SearchPageComponent.prototype.onAviationEventsFiltersDateChanged = function () {
        this.serializeQuery();
        this.searchEvents();
        // this.filteredAviationEvents = this.filterAviationEvents(this.aviationEvents);
    };
    SearchPageComponent.prototype.filterAviationEvents = function (aviationEvents) {
        var _this = this;
        var filteredEvents = [];
        aviationEvents.forEach(function (aviationEvent) {
            if (aviationEvent.type === AviationEventType.Airshow && _this.query.aviationEventsFilter.airshow === true) {
                filteredEvents.push(aviationEvent);
            }
            if (aviationEvent.type === AviationEventType.AirshowwithMilitaryDemonstrationTeam &&
                _this.query.aviationEventsFilter.airshowwithmilitarydemonstrationteam === true) {
                filteredEvents.push(aviationEvent);
            }
            if (aviationEvent.type === AviationEventType.FlyIn && _this.query.aviationEventsFilter.flyin === true) {
                filteredEvents.push(aviationEvent);
            }
            if (aviationEvent.type === AviationEventType.FlyOut && _this.query.aviationEventsFilter.flyout === true) {
                filteredEvents.push(aviationEvent);
            }
            if (aviationEvent.type === AviationEventType.PancakeBreakfast && _this.query.aviationEventsFilter.pancakeBreakfast === true) {
                filteredEvents.push(aviationEvent);
            }
            if (aviationEvent.type === AviationEventType.SocialGathering && _this.query.aviationEventsFilter.socialGathering === true) {
                filteredEvents.push(aviationEvent);
            }
            if (aviationEvent.type === AviationEventType.Openhouse && _this.query.aviationEventsFilter.openhouse === true) {
                filteredEvents.push(aviationEvent);
            }
            if (aviationEvent.type === AviationEventType.PokerRun && _this.query.aviationEventsFilter.pokerRun === true) {
                filteredEvents.push(aviationEvent);
            }
            if (aviationEvent.type === AviationEventType.AviationCommunityDay && _this.query.aviationEventsFilter.aviationCommunityDay === true) {
                filteredEvents.push(aviationEvent);
            }
            if (aviationEvent.type === AviationEventType.WingsAndWheelsEvent && _this.query.aviationEventsFilter.wingsAndWheels === true) {
                filteredEvents.push(aviationEvent);
            }
            if (aviationEvent.type === AviationEventType.AircraftDisplayRides && _this.query.aviationEventsFilter.aircraftDisplayRides === true) {
                filteredEvents.push(aviationEvent);
            }
            if (aviationEvent.type === AviationEventType.RustyPilotsSeminar && _this.query.aviationEventsFilter.aopaRustyPilots === true) {
                filteredEvents.push(aviationEvent);
            }
            if (aviationEvent.type === AviationEventType.FlyingClubSeminar && _this.query.aviationEventsFilter.aopaFlyingClub === true) {
                filteredEvents.push(aviationEvent);
            }
            if (aviationEvent.type === AviationEventType.SafetySeminar && _this.query.aviationEventsFilter.safetySeminar === true) {
                filteredEvents.push(aviationEvent);
            }
            if (aviationEvent.type === AviationEventType.Conference && _this.query.aviationEventsFilter.conference === true) {
                filteredEvents.push(aviationEvent);
            }
            if (aviationEvent.type === AviationEventType.Workshop && _this.query.aviationEventsFilter.workshop === true) {
                filteredEvents.push(aviationEvent);
            }
            if (aviationEvent.type === AviationEventType.BackToYourRoots && _this.query.aviationEventsFilter.aopaBacktoYourRoots === true) {
                filteredEvents.push(aviationEvent);
            }
        });
        var queryStart = moment(new Date(this.query.aviationEventsFilter.startDate).setHours(0, 0, 0, 0));
        var queryEnd = moment(new Date(this.query.aviationEventsFilter.endDate).setHours(23, 59, 59, 999));
        filteredEvents = filteredEvents.filter(function (ae) {
            var eventStart = moment(new Date(ae.startDateTime), 'UTC').tz(ae.timezone);
            var eventEnd = moment(new Date(ae.endDateTime), 'UTC').tz(ae.timezone);
            if ((eventStart >= queryStart && eventStart <= queryEnd) || (eventEnd >= queryStart && eventEnd <= queryEnd)) {
                return true;
            }
            else {
                return false;
            }
        });
        filteredEvents = filteredEvents.filter(function (ae) {
            return ae.title.toLowerCase().includes(_this.query.aviationEventsFilter.name.toLowerCase());
        });
        filteredEvents = filteredEvents.filter(function (ae) {
            if (_this.query.aviationEventsFilter.formatOnline && (ae.format === 'Online' || ae.format === 'Both')) {
                return true;
            }
            else if (_this.query.aviationEventsFilter.formatInPerson && (ae.format === 'In-Person' || ae.format === 'Both') &&
                (ae.location && ae.location.lat && ae.location.lon)) {
                return true;
            }
            else {
                return false;
            }
        });
        // check to see if there are any visible in-person events
        var visibleInPersonEvents = filteredEvents.some(function (ae) {
            if ((ae.format === 'Both' || ae.format === 'In-Person') && ae.location && ae.location.lat && ae.location.lon) {
                return true;
            }
            return false;
        });
        if (visibleInPersonEvents) {
            if (this.mapMessage && this.mapMessage.startsWith('Zoom in to update ')) {
            }
            else {
                this.mapMessage = null;
            }
        }
        else {
            if (this.query.aviationEventsFilter.formatOnline && !this.query.aviationEventsFilter.formatInPerson) {
                this.mapMessage = 'You have filtered out In-Person events';
            }
            else if (this.query.aviationEventsFilter.formatInPerson) {
                this.mapMessage = 'No In-Person events to show in this area';
            }
        }
        return filteredEvents;
    };
    SearchPageComponent.prototype.searchEvents = function (keepPriceSliderState) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var validationResult, queryStartDate, queryStartDateUTC, queryEndDate, queryEndDateUTC, _a, _b, _c, _d, e_4;
            return tslib_1.__generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _e.trys.push([0, 11, , 12]);
                        validationResult = this.query.validate();
                        if (!validationResult.valid) return [3 /*break*/, 9];
                        this.aviationEventsState = State.Loading;
                        this.form.disableForm();
                        this.serializeQuery();
                        queryStartDate = moment(new Date(this.query.aviationEventsFilter.startDate).setHours(0, 0, 0, 0));
                        queryStartDateUTC = queryStartDate.clone().tz('UTC').format();
                        queryEndDate = moment(new Date(this.query.aviationEventsFilter.endDate).setHours(23, 59, 59, 999));
                        queryEndDateUTC = queryEndDate.clone().tz('UTC').format();
                        if (!(this.query.location && this.query.radius)) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this._aviationEventsService.getAviationEventsByLatLon(this.query.location, this.query.radius, queryStartDateUTC, queryEndDateUTC)];
                    case 1:
                        _a.aviationEvents = _e.sent();
                        if (!this.query.bounds) {
                            this._updateBounds();
                        }
                        return [3 /*break*/, 8];
                    case 2:
                        if (!this.query.bounds) return [3 /*break*/, 4];
                        _b = this;
                        return [4 /*yield*/, this._aviationEventsService.getAviationEventsByBoundingBox(this.query.bounds, queryStartDateUTC, queryEndDateUTC)];
                    case 3:
                        _b.aviationEvents = _e.sent();
                        return [3 /*break*/, 8];
                    case 4:
                        if (!this.query.state) return [3 /*break*/, 6];
                        _c = this;
                        return [4 /*yield*/, this._aviationEventsService.getAviationEventsByState(this.query.state, queryStartDateUTC, queryEndDateUTC)];
                    case 5:
                        _c.aviationEvents = _e.sent();
                        this.activities = [];
                        this.query.state = null;
                        return [3 /*break*/, 8];
                    case 6:
                        _d = this;
                        return [4 /*yield*/, this._aviationEventsService.getAviationEvents(queryStartDateUTC, queryEndDateUTC)];
                    case 7:
                        _d.aviationEvents = _e.sent();
                        _e.label = 8;
                    case 8:
                        this.filteredAviationEvents = this.filterAviationEvents(this.aviationEvents);
                        this.aviationEventsState = State.Content;
                        this.form.enableForm();
                        /* if (!this.query.bounds) {
                          this._updateBounds();
                        } */
                        this.onFiltersChanged(keepPriceSliderState);
                        this.errorMessage = null;
                        return [3 /*break*/, 10];
                    case 9:
                        if (validationResult.reason === QueryValidationReason.MISSING_BASE_PARAMS) {
                            this.aviationEventsState = State.Empty;
                            return [2 /*return*/];
                        }
                        console.warn('Invalid search query validation result:', validationResult, 'Query:', this.query);
                        this.errorMessage = validationResult.message;
                        this.aviationEventsState = State.Error;
                        _e.label = 10;
                    case 10: return [3 /*break*/, 12];
                    case 11:
                        e_4 = _e.sent();
                        this._errorHandler.handleError(e_4);
                        this.aviationEvents = [];
                        this.filteredAviationEvents = [];
                        this.form.enableForm();
                        this.errorMessage = null;
                        this.aviationEventsState = State.Error;
                        return [3 /*break*/, 12];
                    case 12: return [2 /*return*/];
                }
            });
        });
    };
    SearchPageComponent.prototype.onFlyingClubFiltersChanged = function () {
        this.serializeQuery();
        this.filteredFlyingClubs = this.filterFlyingClubs(this.flyingClubs);
    };
    /**
     * Applies the category facets client-side, mirroring the iOS Business filter logic: club-type and
     * Membership use OR logic; Benefits and Types of Flying use AND logic; the keyword matches name or
     * airport ident. (Location/state/keyword narrowing already happened server-side.)
     */
    SearchPageComponent.prototype.filterFlyingClubs = function (flyingClubs) {
        var f = this.query.flyingClubFinderFilter;
        if (!f) {
            return flyingClubs;
        }
        return flyingClubs.filter(function (club) {
            var tags = club.tags || [];
            // Club type (AOPA Network / In Formation) — OR logic within the group.
            var clubTypeFilters = [];
            if (f.aopaNetwork) {
                clubTypeFilters.push('AOPA Network Club');
            }
            if (f.inFormation) {
                clubTypeFilters.push('Club In Formation');
            }
            if (clubTypeFilters.length && clubTypeFilters.indexOf(club.clubType) === -1) {
                return false;
            }
            // Equity / Non-Equity club — OR logic; Hybrid-Equity clubs match whenever either is selected.
            var equityFilters = [];
            if (f.equityClub) {
                equityFilters.push(FLYING_CLUB_EQUITY_TAG);
            }
            if (f.nonEquityClub) {
                equityFilters.push(FLYING_CLUB_NON_EQUITY_TAG);
            }
            if (equityFilters.length && !equityFilters.some(function (t) { return tags.indexOf(t) !== -1; })
                && tags.indexOf(FLYING_CLUB_HYBRID_EQUITY_TAG) === -1) {
                return false;
            }
            // Membership — OR logic (any selected tag).
            if (f.membership.length && !f.membership.some(function (m) { return tags.indexOf(m) !== -1; })) {
                return false;
            }
            // Benefits — AND logic (all selected tags).
            if (f.benefits.length && !f.benefits.every(function (b) { return tags.indexOf(b) !== -1; })) {
                return false;
            }
            // Types of Flying — AND logic.
            if (f.flying.length && !f.flying.every(function (fl) { return tags.indexOf(fl) !== -1; })) {
                return false;
            }
            // Keyword — name or airport ident.
            if (f.name) {
                var term = f.name.toLowerCase();
                var name_1 = (club.name || '').toLowerCase();
                var ident = (club.airportIdent || '').toLowerCase();
                if (name_1.indexOf(term) === -1 && ident.indexOf(term) === -1) {
                    return false;
                }
            }
            return true;
        });
    };
    SearchPageComponent.prototype.searchFlyingClubs = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var validationResult, _a, _b, _c, _d, _e, e_5;
            return tslib_1.__generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _f.trys.push([0, 14, , 15]);
                        // A state search nulls this.query.state after use; on a later tab switch restore it from the preserved
                        // value so validate() passes and this finder re-runs the same state search (see _finderStateProvince).
                        if (!this.query.state && this._finderStateProvince) {
                            this.query.state = this._finderStateProvince;
                        }
                        validationResult = this.query.validate();
                        if (!validationResult.valid) return [3 /*break*/, 12];
                        this.flyingClubsState = State.Loading;
                        this.form.disableForm();
                        this.serializeQuery();
                        if (!(this.query.location && this.query.radius)) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this._flyingClubsService.getFlyingClubsByLatLon(this.query.location, this.query.radius)];
                    case 1:
                        _a.flyingClubs = _f.sent();
                        if (!this.query.bounds) {
                            this._updateBounds();
                        }
                        return [3 /*break*/, 11];
                    case 2:
                        if (!this.query.bounds) return [3 /*break*/, 4];
                        _b = this;
                        return [4 /*yield*/, this._flyingClubsService.getFlyingClubsByBoundingBox(this.query.bounds)];
                    case 3:
                        _b.flyingClubs = _f.sent();
                        return [3 /*break*/, 11];
                    case 4:
                        if (!(this.query.state || this._finderStateProvince)) return [3 /*break*/, 6];
                        _c = this;
                        return [4 /*yield*/, this._flyingClubsService.getFlyingClubsByState(this.query.state || this._finderStateProvince)];
                    case 5:
                        _c.flyingClubs = _f.sent();
                        this.query.state = null;
                        this._updateBounds();
                        return [3 /*break*/, 11];
                    case 6:
                        if (!this.query.term) return [3 /*break*/, 8];
                        // Keyword and ZIP-code searches both arrive as a term; fit the map to the returned clubs so the
                        // results (e.g. clubs near a ZIP) are framed rather than leaving the map zoomed out to CONUS.
                        _d = this;
                        return [4 /*yield*/, this._flyingClubsService.getFlyingClubsBySearchTerm(this.query.term)];
                    case 7:
                        // Keyword and ZIP-code searches both arrive as a term; fit the map to the returned clubs so the
                        // results (e.g. clubs near a ZIP) are framed rather than leaving the map zoomed out to CONUS.
                        _d.flyingClubs = _f.sent();
                        this._updateBounds();
                        return [3 /*break*/, 11];
                    case 8:
                        if (!(this.query.flyingClubFinderFilter && this.query.flyingClubFinderFilter.name)) return [3 /*break*/, 10];
                        // No location was entered, but a club name was: search by name (server-side name/ident match).
                        _e = this;
                        return [4 /*yield*/, this._flyingClubsService.getFlyingClubsBySearchTerm(this.query.flyingClubFinderFilter.name)];
                    case 9:
                        // No location was entered, but a club name was: search by name (server-side name/ident match).
                        _e.flyingClubs = _f.sent();
                        this._updateBounds();
                        return [3 /*break*/, 11];
                    case 10:
                        this.flyingClubs = [];
                        _f.label = 11;
                    case 11:
                        this.filteredFlyingClubs = this.filterFlyingClubs(this.flyingClubs);
                        this.flyingClubsState = State.Content;
                        this.form.enableForm();
                        this.errorMessage = null;
                        return [3 /*break*/, 13];
                    case 12:
                        if (validationResult.reason === QueryValidationReason.MISSING_BASE_PARAMS) {
                            this.flyingClubsState = State.Empty;
                            return [2 /*return*/];
                        }
                        console.warn('Invalid search query validation result:', validationResult, 'Query:', this.query);
                        this.errorMessage = validationResult.message;
                        this.flyingClubsState = State.Error;
                        _f.label = 13;
                    case 13: return [3 /*break*/, 15];
                    case 14:
                        e_5 = _f.sent();
                        this._errorHandler.handleError(e_5);
                        this.flyingClubs = [];
                        this.filteredFlyingClubs = [];
                        this.form.enableForm();
                        this.errorMessage = null;
                        this.flyingClubsState = State.Error;
                        return [3 /*break*/, 15];
                    case 15: return [2 /*return*/];
                }
            });
        });
    };
    SearchPageComponent.prototype.onFlightSchoolFiltersChanged = function () {
        this.serializeQuery();
        this.filteredFlightSchools = this.filterFlightSchools(this.flightSchools);
    };
    /**
     * Applies the category facets client-side, mirroring the iOS Business filter logic: Training Type uses OR
     * logic (Part 61 OR Part 141); Certifications / Ratings / Advanced / Services / Additional use AND logic;
     * the keyword matches name or airport ident. (Location/state/keyword narrowing already happened
     * server-side.)
     */
    SearchPageComponent.prototype.filterFlightSchools = function (flightSchools) {
        var f = this.query.flightSchoolFinderFilter;
        if (!f) {
            return flightSchools;
        }
        return flightSchools.filter(function (school) {
            var tags = school.tags || [];
            // Training Type — OR logic (any selected tag).
            if (f.classification.length && !f.classification.some(function (c) { return tags.indexOf(c) !== -1; })) {
                return false;
            }
            // Certifications — AND logic (all selected tags).
            if (f.certifications.length && !f.certifications.every(function (c) { return tags.indexOf(c) !== -1; })) {
                return false;
            }
            // Ratings — AND logic.
            if (f.ratings.length && !f.ratings.every(function (r) { return tags.indexOf(r) !== -1; })) {
                return false;
            }
            // Advanced Training — AND logic.
            if (f.advanced.length && !f.advanced.every(function (a) { return tags.indexOf(a) !== -1; })) {
                return false;
            }
            // Services — AND logic.
            if (f.services.length && !f.services.every(function (s) { return tags.indexOf(s) !== -1; })) {
                return false;
            }
            // Additional (VA Approved / College Affiliated) — AND logic.
            if (f.other.length && !f.other.every(function (o) { return tags.indexOf(o) !== -1; })) {
                return false;
            }
            // Keyword — name or airport ident.
            if (f.name) {
                var term = f.name.toLowerCase();
                var name_2 = (school.name || '').toLowerCase();
                var ident = (school.airportIdent || '').toLowerCase();
                if (name_2.indexOf(term) === -1 && ident.indexOf(term) === -1) {
                    return false;
                }
            }
            return true;
        });
    };
    SearchPageComponent.prototype.searchFlightSchools = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var validationResult, _a, _b, _c, _d, _e, e_6;
            return tslib_1.__generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _f.trys.push([0, 14, , 15]);
                        // A state search nulls this.query.state after use; on a later tab switch restore it from the preserved
                        // value so validate() passes and this finder re-runs the same state search (see _finderStateProvince).
                        if (!this.query.state && this._finderStateProvince) {
                            this.query.state = this._finderStateProvince;
                        }
                        validationResult = this.query.validate();
                        if (!validationResult.valid) return [3 /*break*/, 12];
                        this.flightSchoolsState = State.Loading;
                        this.form.disableForm();
                        this.serializeQuery();
                        if (!(this.query.location && this.query.radius)) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this._flightSchoolsService.getFlightSchoolsByLatLon(this.query.location, this.query.radius)];
                    case 1:
                        _a.flightSchools = _f.sent();
                        if (!this.query.bounds) {
                            this._updateBounds();
                        }
                        return [3 /*break*/, 11];
                    case 2:
                        if (!this.query.bounds) return [3 /*break*/, 4];
                        _b = this;
                        return [4 /*yield*/, this._flightSchoolsService.getFlightSchoolsByBoundingBox(this.query.bounds)];
                    case 3:
                        _b.flightSchools = _f.sent();
                        return [3 /*break*/, 11];
                    case 4:
                        if (!(this.query.state || this._finderStateProvince)) return [3 /*break*/, 6];
                        _c = this;
                        return [4 /*yield*/, this._flightSchoolsService.getFlightSchoolsByState(this.query.state || this._finderStateProvince)];
                    case 5:
                        _c.flightSchools = _f.sent();
                        this.query.state = null;
                        this._updateBounds();
                        return [3 /*break*/, 11];
                    case 6:
                        if (!this.query.term) return [3 /*break*/, 8];
                        // Keyword and ZIP-code searches both arrive as a term; fit the map to the returned schools so the
                        // results (e.g. schools near a ZIP) are framed rather than leaving the map zoomed out to CONUS.
                        _d = this;
                        return [4 /*yield*/, this._flightSchoolsService.getFlightSchoolsBySearchTerm(this.query.term)];
                    case 7:
                        // Keyword and ZIP-code searches both arrive as a term; fit the map to the returned schools so the
                        // results (e.g. schools near a ZIP) are framed rather than leaving the map zoomed out to CONUS.
                        _d.flightSchools = _f.sent();
                        this._updateBounds();
                        return [3 /*break*/, 11];
                    case 8:
                        if (!(this.query.flightSchoolFinderFilter && this.query.flightSchoolFinderFilter.name)) return [3 /*break*/, 10];
                        // No location was entered, but a school name was: search by name (server-side name/ident match).
                        _e = this;
                        return [4 /*yield*/, this._flightSchoolsService.getFlightSchoolsBySearchTerm(this.query.flightSchoolFinderFilter.name)];
                    case 9:
                        // No location was entered, but a school name was: search by name (server-side name/ident match).
                        _e.flightSchools = _f.sent();
                        this._updateBounds();
                        return [3 /*break*/, 11];
                    case 10:
                        this.flightSchools = [];
                        _f.label = 11;
                    case 11:
                        this.filteredFlightSchools = this.filterFlightSchools(this.flightSchools);
                        this.flightSchoolsState = State.Content;
                        this.form.enableForm();
                        this.errorMessage = null;
                        return [3 /*break*/, 13];
                    case 12:
                        if (validationResult.reason === QueryValidationReason.MISSING_BASE_PARAMS) {
                            this.flightSchoolsState = State.Empty;
                            return [2 /*return*/];
                        }
                        console.warn('Invalid search query validation result:', validationResult, 'Query:', this.query);
                        this.errorMessage = validationResult.message;
                        this.flightSchoolsState = State.Error;
                        _f.label = 13;
                    case 13: return [3 /*break*/, 15];
                    case 14:
                        e_6 = _f.sent();
                        this._errorHandler.handleError(e_6);
                        this.flightSchools = [];
                        this.filteredFlightSchools = [];
                        this.form.enableForm();
                        this.errorMessage = null;
                        this.flightSchoolsState = State.Error;
                        return [3 /*break*/, 15];
                    case 15: return [2 /*return*/];
                }
            });
        });
    };
    SearchPageComponent.prototype.onUniversityFiltersChanged = function () {
        this.serializeQuery();
        this.filteredUniversities = this.filterUniversities(this.universities);
    };
    /**
     * Applies the category facets client-side, mirroring the iOS Business filter logic for colleges: Degrees /
     * Majors / Accreditation / Additional all use AND logic (empty `orLogicCategories`); the keyword matches
     * name or airport ident. (Location/state/keyword narrowing already happened server-side.)
     */
    SearchPageComponent.prototype.filterUniversities = function (universities) {
        var f = this.query.universityFinderFilter;
        if (!f) {
            return universities;
        }
        return universities.filter(function (university) {
            var tags = university.tags || [];
            // Degrees — AND logic (all selected tags).
            if (f.degrees.length && !f.degrees.every(function (d) { return tags.indexOf(d) !== -1; })) {
                return false;
            }
            // Majors — AND logic.
            if (f.majors.length && !f.majors.every(function (m) { return tags.indexOf(m) !== -1; })) {
                return false;
            }
            // Accreditation — AND logic.
            if (f.accreditation.length && !f.accreditation.every(function (a) { return tags.indexOf(a) !== -1; })) {
                return false;
            }
            // Additional (VA Approved / Distance Learning) — AND logic.
            if (f.options.length && !f.options.every(function (o) { return tags.indexOf(o) !== -1; })) {
                return false;
            }
            // Keyword — name or airport ident.
            if (f.name) {
                var term = f.name.toLowerCase();
                var name_3 = (university.name || '').toLowerCase();
                var ident = (university.airportIdent || '').toLowerCase();
                if (name_3.indexOf(term) === -1 && ident.indexOf(term) === -1) {
                    return false;
                }
            }
            return true;
        });
    };
    SearchPageComponent.prototype.searchUniversities = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var validationResult, _a, _b, _c, _d, _e, _f, e_7;
            return tslib_1.__generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        _g.trys.push([0, 15, , 16]);
                        // A state search nulls this.query.state after use; on a later tab switch restore it from the preserved
                        // value so validate() passes and this finder re-runs the same state search (see _finderStateProvince).
                        if (!this.query.state && this._finderStateProvince) {
                            this.query.state = this._finderStateProvince;
                        }
                        validationResult = this.query.validate();
                        if (!validationResult.valid) return [3 /*break*/, 13];
                        this.universitiesState = State.Loading;
                        this.form.disableForm();
                        this.serializeQuery();
                        if (!(this.query.location && this.query.radius)) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this._universitiesService.getUniversitiesByLatLon(this.query.location, this.query.radius)];
                    case 1:
                        _a.universities = _g.sent();
                        if (!this.query.bounds) {
                            this._updateBounds();
                        }
                        return [3 /*break*/, 12];
                    case 2:
                        if (!this.query.bounds) return [3 /*break*/, 4];
                        _b = this;
                        return [4 /*yield*/, this._universitiesService.getUniversitiesByBoundingBox(this.query.bounds)];
                    case 3:
                        _b.universities = _g.sent();
                        return [3 /*break*/, 12];
                    case 4:
                        if (!(this.query.state || this._finderStateProvince)) return [3 /*break*/, 6];
                        _c = this;
                        return [4 /*yield*/, this._universitiesService.getUniversitiesByState(this.query.state || this._finderStateProvince)];
                    case 5:
                        _c.universities = _g.sent();
                        this.query.state = null;
                        this._updateBounds();
                        return [3 /*break*/, 12];
                    case 6:
                        if (!this.query.term) return [3 /*break*/, 8];
                        // Keyword and ZIP-code searches both arrive as a term; fit the map to the returned universities so
                        // the results (e.g. universities near a ZIP) are framed rather than leaving the map zoomed out.
                        _d = this;
                        return [4 /*yield*/, this._universitiesService.getUniversitiesBySearchTerm(this.query.term)];
                    case 7:
                        // Keyword and ZIP-code searches both arrive as a term; fit the map to the returned universities so
                        // the results (e.g. universities near a ZIP) are framed rather than leaving the map zoomed out.
                        _d.universities = _g.sent();
                        this._updateBounds();
                        return [3 /*break*/, 12];
                    case 8:
                        if (!(this.query.universityFinderFilter
                            && AirportService.sanitizeSearchTerm(this.query.universityFinderFilter.name).length >= 3)) return [3 /*break*/, 10];
                        // No location was entered, but a university name was: search by name (server-side name/ident match).
                        _e = this;
                        return [4 /*yield*/, this._universitiesService.getUniversitiesBySearchTerm(this.query.universityFinderFilter.name)];
                    case 9:
                        // No location was entered, but a university name was: search by name (server-side name/ident match).
                        _e.universities = _g.sent();
                        this._updateBounds();
                        return [3 /*break*/, 12];
                    case 10:
                        // No location, state, or keyword was entered. Universities are few enough nationwide (~300) that
                        // an unscoped search returns every university rather than requiring a location.
                        _f = this;
                        return [4 /*yield*/, this._universitiesService.getAllUniversities()];
                    case 11:
                        // No location, state, or keyword was entered. Universities are few enough nationwide (~300) that
                        // an unscoped search returns every university rather than requiring a location.
                        _f.universities = _g.sent();
                        this._updateBounds();
                        _g.label = 12;
                    case 12:
                        this.filteredUniversities = this.filterUniversities(this.universities);
                        this.universitiesState = State.Content;
                        this.form.enableForm();
                        this.errorMessage = null;
                        return [3 /*break*/, 14];
                    case 13:
                        if (validationResult.reason === QueryValidationReason.MISSING_BASE_PARAMS) {
                            this.universitiesState = State.Empty;
                            return [2 /*return*/];
                        }
                        console.warn('Invalid search query validation result:', validationResult, 'Query:', this.query);
                        this.errorMessage = validationResult.message;
                        this.universitiesState = State.Error;
                        _g.label = 14;
                    case 14: return [3 /*break*/, 16];
                    case 15:
                        e_7 = _g.sent();
                        this._errorHandler.handleError(e_7);
                        this.universities = [];
                        this.filteredUniversities = [];
                        this.form.enableForm();
                        this.errorMessage = null;
                        this.universitiesState = State.Error;
                        return [3 /*break*/, 16];
                    case 16: return [2 /*return*/];
                }
            });
        });
    };
    SearchPageComponent.prototype.onFboFiltersChanged = function () {
        this.serializeQuery();
        this.filteredFbos = this.filterFbos(this.fbos);
    };
    /**
     * Applies the category facets client-side, mirroring the iOS FBO filter logic: Fuel / Fuel Type / Rental
     * Car / Transportation use OR logic; Amenities / Facilities / Line Services use AND logic; the keyword
     * matches name or airport ident. Fuel Type matches the FBO's fuel types (from the BusinessFuel table),
     * everything else matches the tag list. (Location/state/keyword narrowing already happened server-side.)
     */
    SearchPageComponent.prototype.filterFbos = function (fbos) {
        var f = this.query.fboFinderFilter;
        if (!f) {
            return fbos;
        }
        return fbos.filter(function (fbo) {
            var tags = fbo.tags || [];
            var fuelTypes = fbo.fuelTypes || [];
            // Amenities — AND logic (all selected tags).
            if (f.amenities.length && !f.amenities.every(function (a) { return tags.indexOf(a) !== -1; })) {
                return false;
            }
            // Facilities — AND logic.
            if (f.facilities.length && !f.facilities.every(function (fa) { return tags.indexOf(fa) !== -1; })) {
                return false;
            }
            // Line Services — AND logic.
            if (f.lineServices.length && !f.lineServices.every(function (l) { return tags.indexOf(l) !== -1; })) {
                return false;
            }
            // Fuel — OR logic (any selected tag).
            if (f.fuel.length && !f.fuel.some(function (fu) { return tags.indexOf(fu) !== -1; })) {
                return false;
            }
            // Fuel Type — OR logic, matched against the FBO's fuel types (not tags).
            if (f.fuelType.length && !f.fuelType.some(function (ft) { return fuelTypes.indexOf(ft) !== -1; })) {
                return false;
            }
            // Rental Car — OR logic.
            if (f.rentalCar.length && !f.rentalCar.some(function (rc) { return tags.indexOf(rc) !== -1; })) {
                return false;
            }
            // Transportation — OR logic.
            if (f.transportation.length && !f.transportation.some(function (t) { return tags.indexOf(t) !== -1; })) {
                return false;
            }
            // Keyword — name or airport ident.
            if (f.name) {
                var term = f.name.toLowerCase();
                var name_4 = (fbo.name || '').toLowerCase();
                var ident = (fbo.airportIdent || '').toLowerCase();
                if (name_4.indexOf(term) === -1 && ident.indexOf(term) === -1) {
                    return false;
                }
            }
            return true;
        });
    };
    SearchPageComponent.prototype.searchFbos = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var validationResult, _a, _b, _c, _d, _e, e_8;
            return tslib_1.__generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _f.trys.push([0, 14, , 15]);
                        // A state search nulls this.query.state after use; on a later tab switch restore it from the preserved
                        // value so validate() passes and this finder re-runs the same state search (see _finderStateProvince).
                        if (!this.query.state && this._finderStateProvince) {
                            this.query.state = this._finderStateProvince;
                        }
                        validationResult = this.query.validate();
                        if (!validationResult.valid) return [3 /*break*/, 12];
                        this.fbosState = State.Loading;
                        this.form.disableForm();
                        this.serializeQuery();
                        if (!(this.query.location && this.query.radius)) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this._fbosService.getFbosByLatLon(this.query.location, this.query.radius)];
                    case 1:
                        _a.fbos = _f.sent();
                        if (!this.query.bounds) {
                            this._updateBounds();
                        }
                        return [3 /*break*/, 11];
                    case 2:
                        if (!this.query.bounds) return [3 /*break*/, 4];
                        _b = this;
                        return [4 /*yield*/, this._fbosService.getFbosByBoundingBox(this.query.bounds)];
                    case 3:
                        _b.fbos = _f.sent();
                        return [3 /*break*/, 11];
                    case 4:
                        if (!(this.query.state || this._finderStateProvince)) return [3 /*break*/, 6];
                        _c = this;
                        return [4 /*yield*/, this._fbosService.getFbosByState(this.query.state || this._finderStateProvince)];
                    case 5:
                        _c.fbos = _f.sent();
                        this.query.state = null;
                        this._updateBounds();
                        return [3 /*break*/, 11];
                    case 6:
                        if (!this.query.term) return [3 /*break*/, 8];
                        // Keyword and ZIP-code searches both arrive as a term; fit the map to the returned FBOs so the
                        // results (e.g. FBOs near a ZIP) are framed rather than leaving the map zoomed out to CONUS.
                        _d = this;
                        return [4 /*yield*/, this._fbosService.getFbosBySearchTerm(this.query.term)];
                    case 7:
                        // Keyword and ZIP-code searches both arrive as a term; fit the map to the returned FBOs so the
                        // results (e.g. FBOs near a ZIP) are framed rather than leaving the map zoomed out to CONUS.
                        _d.fbos = _f.sent();
                        this._updateBounds();
                        return [3 /*break*/, 11];
                    case 8:
                        if (!(this.query.fboFinderFilter && this.query.fboFinderFilter.name)) return [3 /*break*/, 10];
                        // No location was entered, but an FBO name was: search by name (server-side name/ident match).
                        _e = this;
                        return [4 /*yield*/, this._fbosService.getFbosBySearchTerm(this.query.fboFinderFilter.name)];
                    case 9:
                        // No location was entered, but an FBO name was: search by name (server-side name/ident match).
                        _e.fbos = _f.sent();
                        this._updateBounds();
                        return [3 /*break*/, 11];
                    case 10:
                        this.fbos = [];
                        _f.label = 11;
                    case 11:
                        this.filteredFbos = this.filterFbos(this.fbos);
                        this.fbosState = State.Content;
                        this.form.enableForm();
                        this.errorMessage = null;
                        return [3 /*break*/, 13];
                    case 12:
                        if (validationResult.reason === QueryValidationReason.MISSING_BASE_PARAMS) {
                            this.fbosState = State.Empty;
                            return [2 /*return*/];
                        }
                        console.warn('Invalid search query validation result:', validationResult, 'Query:', this.query);
                        this.errorMessage = validationResult.message;
                        this.fbosState = State.Error;
                        _f.label = 13;
                    case 13: return [3 /*break*/, 15];
                    case 14:
                        e_8 = _f.sent();
                        this._errorHandler.handleError(e_8);
                        this.fbos = [];
                        this.filteredFbos = [];
                        this.form.enableForm();
                        this.errorMessage = null;
                        this.fbosState = State.Error;
                        return [3 /*break*/, 15];
                    case 15: return [2 /*return*/];
                }
            });
        });
    };
    SearchPageComponent.prototype.onServiceRepairFiltersChanged = function () {
        this.serializeQuery();
        this.filteredServiceRepairs = this.filterServiceRepairs(this.serviceRepairs);
    };
    /**
     * Applies the category facets client-side. So a user sees only the shops that can do everything they need,
     * each SERVICE group (Airframe / Avionics / Powerplant / Propeller / Interior / Exterior / Rotor) uses AND
     * within the group — a shop must offer every selected service — while each MANUFACTURER subsection uses OR
     * (a shop that services any of the selected makes qualifies, since you have one make). Groups are AND'd
     * together, and the keyword matches name or airport ident. (Location/state/keyword narrowing already
     * happened server-side.)
     */
    SearchPageComponent.prototype.filterServiceRepairs = function (serviceRepairs) {
        var f = this.query.serviceRepairFinderFilter;
        if (!f) {
            return serviceRepairs;
        }
        // Service facets: AND within the group (a shop must offer every selected service).
        var serviceGroups = [
            f.airframe, f.avionics, f.powerplant, f.propeller, f.interior, f.exterior, f.rotor
        ];
        // Manufacturer facets: OR within the group (a shop that services any of the selected makes).
        var manufacturerGroups = [
            f.airframeManufacturers, f.avionicsManufacturers, f.powerplantManufacturers, f.propellerManufacturers
        ];
        return serviceRepairs.filter(function (sr) {
            var tags = sr.tags || [];
            // AND within each service group, OR within each manufacturer group, AND across all groups.
            for (var _i = 0, serviceGroups_1 = serviceGroups; _i < serviceGroups_1.length; _i++) {
                var group = serviceGroups_1[_i];
                if (group.length && !group.every(function (t) { return tags.indexOf(t) !== -1; })) {
                    return false;
                }
            }
            for (var _a = 0, manufacturerGroups_1 = manufacturerGroups; _a < manufacturerGroups_1.length; _a++) {
                var group = manufacturerGroups_1[_a];
                if (group.length && !group.some(function (t) { return tags.indexOf(t) !== -1; })) {
                    return false;
                }
            }
            // Keyword — name or airport ident.
            if (f.name) {
                var term = f.name.toLowerCase();
                var name_5 = (sr.name || '').toLowerCase();
                var ident = (sr.airportIdent || '').toLowerCase();
                if (name_5.indexOf(term) === -1 && ident.indexOf(term) === -1) {
                    return false;
                }
            }
            return true;
        });
    };
    SearchPageComponent.prototype.searchServiceRepairs = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var validationResult, _a, _b, _c, _d, _e, e_9;
            return tslib_1.__generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _f.trys.push([0, 14, , 15]);
                        // A state search nulls this.query.state after use; on a later tab switch restore it from the preserved
                        // value so validate() passes and this finder re-runs the same state search (see _finderStateProvince).
                        if (!this.query.state && this._finderStateProvince) {
                            this.query.state = this._finderStateProvince;
                        }
                        validationResult = this.query.validate();
                        if (!validationResult.valid) return [3 /*break*/, 12];
                        this.serviceRepairsState = State.Loading;
                        this.form.disableForm();
                        this.serializeQuery();
                        if (!(this.query.location && this.query.radius)) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this._serviceRepairsService.getServiceRepairsByLatLon(this.query.location, this.query.radius)];
                    case 1:
                        _a.serviceRepairs = _f.sent();
                        if (!this.query.bounds) {
                            this._updateBounds();
                        }
                        return [3 /*break*/, 11];
                    case 2:
                        if (!this.query.bounds) return [3 /*break*/, 4];
                        _b = this;
                        return [4 /*yield*/, this._serviceRepairsService.getServiceRepairsByBoundingBox(this.query.bounds)];
                    case 3:
                        _b.serviceRepairs = _f.sent();
                        return [3 /*break*/, 11];
                    case 4:
                        if (!(this.query.state || this._finderStateProvince)) return [3 /*break*/, 6];
                        _c = this;
                        return [4 /*yield*/, this._serviceRepairsService.getServiceRepairsByState(this.query.state || this._finderStateProvince)];
                    case 5:
                        _c.serviceRepairs = _f.sent();
                        this.query.state = null;
                        this._updateBounds();
                        return [3 /*break*/, 11];
                    case 6:
                        if (!this.query.term) return [3 /*break*/, 8];
                        // Keyword and ZIP-code searches both arrive as a term; fit the map to the returned businesses so the
                        // results (e.g. shops near a ZIP) are framed rather than leaving the map zoomed out to CONUS.
                        _d = this;
                        return [4 /*yield*/, this._serviceRepairsService.getServiceRepairsBySearchTerm(this.query.term)];
                    case 7:
                        // Keyword and ZIP-code searches both arrive as a term; fit the map to the returned businesses so the
                        // results (e.g. shops near a ZIP) are framed rather than leaving the map zoomed out to CONUS.
                        _d.serviceRepairs = _f.sent();
                        this._updateBounds();
                        return [3 /*break*/, 11];
                    case 8:
                        if (!(this.query.serviceRepairFinderFilter && this.query.serviceRepairFinderFilter.name)) return [3 /*break*/, 10];
                        // No location was entered, but a business name was: search by name (server-side name/ident match).
                        _e = this;
                        return [4 /*yield*/, this._serviceRepairsService.getServiceRepairsBySearchTerm(this.query.serviceRepairFinderFilter.name)];
                    case 9:
                        // No location was entered, but a business name was: search by name (server-side name/ident match).
                        _e.serviceRepairs = _f.sent();
                        this._updateBounds();
                        return [3 /*break*/, 11];
                    case 10:
                        this.serviceRepairs = [];
                        _f.label = 11;
                    case 11:
                        this.filteredServiceRepairs = this.filterServiceRepairs(this.serviceRepairs);
                        this.serviceRepairsState = State.Content;
                        this.form.enableForm();
                        this.errorMessage = null;
                        return [3 /*break*/, 13];
                    case 12:
                        if (validationResult.reason === QueryValidationReason.MISSING_BASE_PARAMS) {
                            this.serviceRepairsState = State.Empty;
                            return [2 /*return*/];
                        }
                        console.warn('Invalid search query validation result:', validationResult, 'Query:', this.query);
                        this.errorMessage = validationResult.message;
                        this.serviceRepairsState = State.Error;
                        _f.label = 13;
                    case 13: return [3 /*break*/, 15];
                    case 14:
                        e_9 = _f.sent();
                        this._errorHandler.handleError(e_9);
                        this.serviceRepairs = [];
                        this.filteredServiceRepairs = [];
                        this.form.enableForm();
                        this.errorMessage = null;
                        this.serviceRepairsState = State.Error;
                        return [3 /*break*/, 15];
                    case 15: return [2 /*return*/];
                }
            });
        });
    };
    SearchPageComponent.prototype.onRentalSalesFiltersChanged = function () {
        this.serializeQuery();
        this.filteredRentalSales = this.filterRentalSales(this.rentalSales);
    };
    /**
     * Applies the category facets client-side. Aircraft Rental and Avionics Manufacturers use OR within the
     * group (a business offering any of the selected options qualifies) and are AND'd against the other
     * groups as usual. Sales Type and Aircraft Manufacturers get the same OR-within-group treatment, but with
     * one exception: businesses often only fill in one of those two facets, so a business missing just one of
     * them isn't excluded on the missing one — only a category it actually tagged must match the selected
     * filter. A business tagged in NEITHER category is still excluded when either facet has a selection (it's
     * not a plausible aircraft-for-sale match, e.g. a rental-only business). Avionics Manufacturers gets no
     * such leniency since avionics being sold can always be assumed new (there's no missing-category
     * ambiguity to account for). The keyword matches name or airport ident. (Location/state/keyword narrowing
     * already happened server-side.)
     */
    SearchPageComponent.prototype.filterRentalSales = function (rentalSales) {
        var f = this.query.rentalSalesFinderFilter;
        if (!f) {
            return rentalSales;
        }
        var SALES_TYPE_PREFIX = 'Sales::Types::';
        var AIRCRAFT_MANUFACTURER_PREFIX = 'Sales::Aircraft::';
        return rentalSales.filter(function (rs) {
            var tags = rs.tags || [];
            // Aircraft Rental — OR within the group, AND'd against the other groups.
            if (f.aircraftRental.length && !f.aircraftRental.some(function (t) { return tags.indexOf(t) !== -1; })) {
                return false;
            }
            // Sales Type / Aircraft Manufacturers — businesses often only fill in one of the two, so a business
            // missing just one category isn't excluded on it. But a business tagged in NEITHER category isn't a
            // plausible match for a Sales Type/Manufacturer search at all (e.g. a rental-only business with no
            // aircraft for sale), so it's still excluded rather than passing both checks by default.
            var hasSalesTypeTags = tags.some(function (t) { return t.indexOf(SALES_TYPE_PREFIX) === 0; });
            var hasAircraftManufacturerTags = tags.some(function (t) { return t.indexOf(AIRCRAFT_MANUFACTURER_PREFIX) === 0; });
            if ((f.salesTypes.length || f.aircraftSalesManufacturers.length)
                && !hasSalesTypeTags && !hasAircraftManufacturerTags) {
                return false;
            }
            if (f.salesTypes.length && hasSalesTypeTags && !f.salesTypes.some(function (t) { return tags.indexOf(t) !== -1; })) {
                return false;
            }
            if (f.aircraftSalesManufacturers.length && hasAircraftManufacturerTags
                && !f.aircraftSalesManufacturers.some(function (t) { return tags.indexOf(t) !== -1; })) {
                return false;
            }
            // Avionics Manufacturers — no leniency; strict OR-within-group match as before.
            if (f.avionicsSalesManufacturers.length && !f.avionicsSalesManufacturers.some(function (t) { return tags.indexOf(t) !== -1; })) {
                return false;
            }
            // Keyword — name or airport ident.
            if (f.name) {
                var term = f.name.toLowerCase();
                var name_6 = (rs.name || '').toLowerCase();
                var ident = (rs.airportIdent || '').toLowerCase();
                if (name_6.indexOf(term) === -1 && ident.indexOf(term) === -1) {
                    return false;
                }
            }
            return true;
        });
    };
    SearchPageComponent.prototype.searchRentalSales = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var validationResult, _a, _b, _c, _d, _e, e_10;
            return tslib_1.__generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _f.trys.push([0, 14, , 15]);
                        // A state search nulls this.query.state after use; on a later tab switch restore it from the preserved
                        // value so validate() passes and this finder re-runs the same state search (see _finderStateProvince).
                        if (!this.query.state && this._finderStateProvince) {
                            this.query.state = this._finderStateProvince;
                        }
                        validationResult = this.query.validate();
                        if (!validationResult.valid) return [3 /*break*/, 12];
                        this.rentalSalesState = State.Loading;
                        this.form.disableForm();
                        this.serializeQuery();
                        if (!(this.query.location && this.query.radius)) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this._rentalSalesService.getRentalSalesByLatLon(this.query.location, this.query.radius)];
                    case 1:
                        _a.rentalSales = _f.sent();
                        if (!this.query.bounds) {
                            this._updateBounds();
                        }
                        return [3 /*break*/, 11];
                    case 2:
                        if (!this.query.bounds) return [3 /*break*/, 4];
                        _b = this;
                        return [4 /*yield*/, this._rentalSalesService.getRentalSalesByBoundingBox(this.query.bounds)];
                    case 3:
                        _b.rentalSales = _f.sent();
                        return [3 /*break*/, 11];
                    case 4:
                        if (!(this.query.state || this._finderStateProvince)) return [3 /*break*/, 6];
                        _c = this;
                        return [4 /*yield*/, this._rentalSalesService.getRentalSalesByState(this.query.state || this._finderStateProvince)];
                    case 5:
                        _c.rentalSales = _f.sent();
                        this.query.state = null;
                        this._updateBounds();
                        return [3 /*break*/, 11];
                    case 6:
                        if (!this.query.term) return [3 /*break*/, 8];
                        // Keyword and ZIP-code searches both arrive as a term; fit the map to the returned businesses so the
                        // results (e.g. businesses near a ZIP) are framed rather than leaving the map zoomed out to CONUS.
                        _d = this;
                        return [4 /*yield*/, this._rentalSalesService.getRentalSalesBySearchTerm(this.query.term)];
                    case 7:
                        // Keyword and ZIP-code searches both arrive as a term; fit the map to the returned businesses so the
                        // results (e.g. businesses near a ZIP) are framed rather than leaving the map zoomed out to CONUS.
                        _d.rentalSales = _f.sent();
                        this._updateBounds();
                        return [3 /*break*/, 11];
                    case 8:
                        if (!(this.query.rentalSalesFinderFilter && this.query.rentalSalesFinderFilter.name)) return [3 /*break*/, 10];
                        // No location was entered, but a business name was: search by name (server-side name/ident match).
                        _e = this;
                        return [4 /*yield*/, this._rentalSalesService.getRentalSalesBySearchTerm(this.query.rentalSalesFinderFilter.name)];
                    case 9:
                        // No location was entered, but a business name was: search by name (server-side name/ident match).
                        _e.rentalSales = _f.sent();
                        this._updateBounds();
                        return [3 /*break*/, 11];
                    case 10:
                        this.rentalSales = [];
                        _f.label = 11;
                    case 11:
                        this.filteredRentalSales = this.filterRentalSales(this.rentalSales);
                        this.rentalSalesState = State.Content;
                        this.form.enableForm();
                        this.errorMessage = null;
                        return [3 /*break*/, 13];
                    case 12:
                        if (validationResult.reason === QueryValidationReason.MISSING_BASE_PARAMS) {
                            this.rentalSalesState = State.Empty;
                            return [2 /*return*/];
                        }
                        console.warn('Invalid search query validation result:', validationResult, 'Query:', this.query);
                        this.errorMessage = validationResult.message;
                        this.rentalSalesState = State.Error;
                        _f.label = 13;
                    case 13: return [3 /*break*/, 15];
                    case 14:
                        e_10 = _f.sent();
                        this._errorHandler.handleError(e_10);
                        this.rentalSales = [];
                        this.filteredRentalSales = [];
                        this.form.enableForm();
                        this.errorMessage = null;
                        this.rentalSalesState = State.Error;
                        return [3 /*break*/, 15];
                    case 15: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Restores the selected airport after performing a search, causing the card to reopen. If the user clicks on an
     * airport, we center the map on the airport and open the card. However, re-centering the map triggers a new search,
     * which clears the markers and causes the card to close. We want to restore the card after the search completes.
     * @private
     */
    SearchPageComponent.prototype._restoreSelectedAirport = function () {
        var _this = this;
        if (!this._selectedAirportId) {
            return;
        }
        setTimeout(function () {
            _this.selectedAirport = _this.filteredAirports.find(function (a) { return a.airportId === _this._selectedAirportId; }) || null;
            // Clear the airport ID. This is mainly to prevent the card from reopening in case it was closed manually. We can't
            // differentiate between the card closing because the user deliberately closed it, vs it getting closed because a
            // new search was triggered after centering the map on the clicked airport.
            _this._selectedAirportId = null;
        }, 300);
    };
    SearchPageComponent.prototype._updateBounds = function () {
        var _this = this;
        this.pauseBounds = true;
        this.map.updateBounds();
        setTimeout(function () {
            _this.pauseBounds = false;
        }, 1000);
    };
    SearchPageComponent.prototype.onAirportCardHover = function (airport, hover) {
        this.activeAirport = airport;
        this.map.toggleAirportInfoTooltip(airport, hover);
    };
    SearchPageComponent.prototype.onActivityCardHover = function (activity, hover) {
        if (hover) {
            this.selectedActivity = activity;
        }
    };
    SearchPageComponent.prototype.onEventCardHover = function (aviationEvent, hover) {
        this.activeAviationEvent = aviationEvent;
        this.map.toggleAviationEventInfoTooltip(aviationEvent, hover);
    };
    SearchPageComponent.prototype.onAirportMarkerHover = function (airport, hover) {
        this.activeAirport = hover ? airport : null;
        if (hover && this.selectedTab === this.airportsTab) {
            this.airportResultsListing.scrollToAirport(airport);
        }
    };
    SearchPageComponent.prototype.onEventMarkerHover = function (aviationEvent, hover) {
        this.activeAviationEvent = hover ? aviationEvent : null;
        if (hover && this.selectedTab === this.aviationEventsTab) {
            this.eventsResultsListing.scrollToEvent(aviationEvent);
        }
    };
    SearchPageComponent.prototype.onFlyingClubCardHover = function (flyingClub, hover) {
        this.activeFlyingClub = flyingClub;
        this.map.toggleFlyingClubInfoTooltip(flyingClub, hover);
    };
    SearchPageComponent.prototype.onFlyingClubMarkerHover = function (flyingClub, hover) {
        this.activeFlyingClub = hover ? flyingClub : null;
        if (hover && this.selectedTab === this.flyingClubsTab) {
            this.flyingClubFinderResultsListing.scrollToFlyingClub(flyingClub);
        }
    };
    SearchPageComponent.prototype.onFlyingClubClick = function (flyingClub) {
        // Record these search results as the "back" target before opening the club (mirrors the results list;
        // see FlyingclubPageComponent.goBack), and clear the airport back-target so search takes precedence.
        if (storageAvailable('sessionStorage')) {
            sessionStorage.setItem('flyingClubSearchReturn', this._router.url);
            sessionStorage.removeItem('lastAirport');
        }
        this._router.navigate(['/flyingclub', flyingClub.businessId]);
    };
    SearchPageComponent.prototype.onFlightSchoolCardHover = function (flightSchool, hover) {
        this.activeFlightSchool = flightSchool;
        this.map.toggleFlightSchoolInfoTooltip(flightSchool, hover);
    };
    SearchPageComponent.prototype.onFlightSchoolMarkerHover = function (flightSchool, hover) {
        this.activeFlightSchool = hover ? flightSchool : null;
        if (hover && this.selectedTab === this.flightSchoolsTab) {
            this.flightSchoolFinderResultsListing.scrollToFlightSchool(flightSchool);
        }
    };
    SearchPageComponent.prototype.onFlightSchoolClick = function (flightSchool) {
        // Record these search results as the "back" target before opening the school (mirrors the results list;
        // see BusinessPageComponent.goBack), and clear the airport back-target so search takes precedence.
        if (storageAvailable('sessionStorage')) {
            sessionStorage.setItem('businessFinderSearchReturn', this._router.url);
            sessionStorage.removeItem('lastAirport');
        }
        this._router.navigate(['/business', flightSchool.businessId]);
    };
    SearchPageComponent.prototype.onUniversityCardHover = function (university, hover) {
        this.activeUniversity = university;
        this.map.toggleUniversityInfoTooltip(university, hover);
    };
    SearchPageComponent.prototype.onUniversityMarkerHover = function (university, hover) {
        this.activeUniversity = hover ? university : null;
        if (hover && this.selectedTab === this.universitiesTab) {
            this.universityFinderResultsListing.scrollToUniversity(university);
        }
    };
    SearchPageComponent.prototype.onUniversityClick = function (university) {
        // Record these search results as the "back" target before opening the university (mirrors the results
        // list; see BusinessPageComponent.goBack), and clear the airport back-target so search takes precedence.
        if (storageAvailable('sessionStorage')) {
            sessionStorage.setItem('businessFinderSearchReturn', this._router.url);
            sessionStorage.removeItem('lastAirport');
        }
        this._router.navigate(['/business', university.businessId]);
    };
    SearchPageComponent.prototype.onFboCardHover = function (fbo, hover) {
        this.activeFbo = fbo;
        this.map.toggleFboInfoTooltip(fbo, hover);
    };
    SearchPageComponent.prototype.onFboMarkerHover = function (fbo, hover) {
        this.activeFbo = hover ? fbo : null;
        if (hover && this.selectedTab === this.fbosTab) {
            this.fboFinderResultsListing.scrollToFbo(fbo);
        }
    };
    SearchPageComponent.prototype.onFboClick = function (fbo) {
        // Record these search results as the "back" target before opening the FBO (mirrors the results list;
        // see BusinessPageComponent.goBack), and clear the airport back-target so search takes precedence.
        if (storageAvailable('sessionStorage')) {
            sessionStorage.setItem('businessFinderSearchReturn', this._router.url);
            sessionStorage.removeItem('lastAirport');
        }
        this._router.navigate(['/business', fbo.businessId]);
    };
    SearchPageComponent.prototype.onServiceRepairCardHover = function (serviceRepair, hover) {
        this.activeServiceRepair = serviceRepair;
        this.map.toggleServiceRepairInfoTooltip(serviceRepair, hover);
    };
    SearchPageComponent.prototype.onServiceRepairMarkerHover = function (serviceRepair, hover) {
        this.activeServiceRepair = hover ? serviceRepair : null;
        if (hover && this.selectedTab === this.serviceRepairsTab) {
            this.serviceRepairFinderResultsListing.scrollToServiceRepair(serviceRepair);
        }
    };
    SearchPageComponent.prototype.onServiceRepairClick = function (serviceRepair) {
        // Record these search results as the "back" target before opening the business (mirrors the results list;
        // see BusinessPageComponent.goBack), and clear the airport back-target so search takes precedence.
        if (storageAvailable('sessionStorage')) {
            sessionStorage.setItem('businessFinderSearchReturn', this._router.url);
            sessionStorage.removeItem('lastAirport');
        }
        this._router.navigate(['/business', serviceRepair.businessId]);
    };
    SearchPageComponent.prototype.onRentalSalesCardHover = function (rentalSales, hover) {
        this.activeRentalSales = rentalSales;
        this.map.toggleRentalSalesInfoTooltip(rentalSales, hover);
    };
    SearchPageComponent.prototype.onRentalSalesMarkerHover = function (rentalSales, hover) {
        this.activeRentalSales = hover ? rentalSales : null;
        if (hover && this.selectedTab === this.rentalSalesTab) {
            this.rentalSalesFinderResultsListing.scrollToRentalSales(rentalSales);
        }
    };
    SearchPageComponent.prototype.onRentalSalesClick = function (rentalSales) {
        // Record these search results as the "back" target before opening the business (mirrors the results list;
        // see BusinessPageComponent.goBack), and clear the airport back-target so search takes precedence.
        if (storageAvailable('sessionStorage')) {
            sessionStorage.setItem('businessFinderSearchReturn', this._router.url);
            sessionStorage.removeItem('lastAirport');
        }
        this._router.navigate(['/business', rentalSales.businessId]);
    };
    SearchPageComponent.prototype.onAirportClick = function (airport) {
        this.selectedAirport = airport;
        this._selectedAirportId = airport.airportId;
        this.map.toggleAirportInfoTooltip(airport, false); // Close tooltip window
        this.map.setCenter(airport.location);
    };
    SearchPageComponent.prototype.onCloseAirportCardWindow = function () {
        var _this = this;
        setTimeout(function () { return _this.selectedAirport = null; }, 0);
    };
    SearchPageComponent.prototype.onCloseActivityWindow = function (activity) {
        var _this = this;
        setTimeout(function () {
            if (_this.selectedActivity === activity) {
                _this.selectedActivity = null;
            }
        }, 0);
    };
    SearchPageComponent.prototype.onActivityMarkerHover = function (activity, hover) {
        if (hover) {
            this.selectedActivity = activity;
            if (this.selectedTab === this.activitiesTab) {
                this.activityResultsListing.scrollToActivity(activity);
            }
        }
    };
    SearchPageComponent.prototype.onActivityClick = function (activity) {
        // do nothing
    };
    SearchPageComponent.prototype.toggleSidebar = function () {
        this.sidebarOpened = !this.sidebarOpened;
        // Initially hide the Back to Search button so it doesn't overlay the sidebar if it is being opened.
        // It may end up being shown again after a delay in onSidebarOpenedChange.
        this.backToSearchVisible = false;
    };
    SearchPageComponent.prototype.onSidebarOpenedChange = function () {
        var _this = this;
        setTimeout(function () {
            _this.map.updateSize();
            _this.updateBackToSearch();
        }, 300);
    };
    SearchPageComponent.prototype.serializeQuery = function () {
        this.query.type = this.searchType;
        this.query.aviationEventsFilter = this.aviationEventFilter;
        this.query.flyingClubFinderFilter = this.flyingClubFinderFilter;
        this.query.flightSchoolFinderFilter = this.flightSchoolFinderFilter;
        this.query.universityFinderFilter = this.universityFinderFilter;
        this.query.fboFinderFilter = this.fboFinderFilter;
        this.query.serviceRepairFinderFilter = this.serviceRepairFinderFilter;
        this.query.rentalSalesFinderFilter = this.rentalSalesFinderFilter;
        var params = this.query.encode();
        this._router.navigate([], { queryParams: params, replaceUrl: true });
    };
    SearchPageComponent.prototype.deserializeQuery = function () {
        this.query = SearchQuery.decode(this._route.snapshot.queryParamMap);
        // Preserve the state search for finder tab-switching (see _finderStateProvince).
        this._finderStateProvince = this.query.state || null;
        if ((this.query.location || this.query.state) && this.query.locationDescription) {
            this.form.setQueryFieldValue(this.query.locationDescription);
        }
    };
    SearchPageComponent.prototype.onFiltersChanged = function (keepPriceSliderState) {
        var _this = this;
        this.serializeQuery();
        this.filteredAirports = this.query.execute(this.airports);
        if (this.query.bounds) {
            var declutterDistance = this.calculateDeclutterDistance(this.query.bounds.getAreaDegrees());
            if (declutterDistance > 0) {
                this.declutteredAirports = this.declutterMapMarkers(this.filteredAirports, declutterDistance);
            }
            else {
                this.declutteredAirports = this.filteredAirports;
            }
        }
        else {
            this.declutteredAirports = this.filteredAirports;
        }
        var anyFuelPriceFilterApplied = this.airportResultsListing.airportFilters.fuel100LLFilter.enabled
            || this.airportResultsListing.airportFilters.fuelJetAFilter.enabled
            || this.airportResultsListing.airportFilters.fuelMOGASFilter.enabled
            || this.airportResultsListing.airportFilters.fuelUL94Filter.enabled;
        // toggle on and off automatically when clicking fuel price filter
        if (keepPriceSliderState != null) {
            if (!keepPriceSliderState && anyFuelPriceFilterApplied) {
                this.airportResultsListing.showPrices = true;
            }
            else if (!keepPriceSliderState && !anyFuelPriceFilterApplied) {
                this.airportResultsListing.showPrices = false;
            }
        }
        if (anyFuelPriceFilterApplied && this.airportResultsListing.showPrices) {
            if (!this.declutteredAirports || this.declutteredAirports.length < 1) {
                return;
            }
            // divide min fuel prices for each airport into high, med, and low
            this.declutteredAirports.forEach(function (a) { return a.minPrice = _this.getMinFuel(a); });
            var lowMedIndexThreshold_1 = Math.ceil(this.declutteredAirports.length / 3);
            var medHighIndexThreshold_1 = this.declutteredAirports.length === 2 ? lowMedIndexThreshold_1 : lowMedIndexThreshold_1 * 2;
            this.declutteredAirports.sort(function (a, b) { return a.minPrice - b.minPrice; });
            this.declutteredAirports.forEach(function (a, i) { return a.minPriceType = _this.getMinPriceType(i, lowMedIndexThreshold_1, medHighIndexThreshold_1); });
        }
        else {
            // reset minPrice and minPriceType to null
            this.declutteredAirports.forEach(function (a) {
                a.minPrice = null;
                a.minPriceType = null;
            });
        }
    };
    SearchPageComponent.prototype.getMinFuel = function (airport) {
        var _this = this;
        if ((airport.fuel || []).length < 1) {
            return null;
        }
        var minFuel = airport.fuel
            .filter(function (f) {
            if (_this.fuelType === FuelType.JetA && (f.fuelType === FuelType.JetA || f.fuelType === FuelType.JetAPremix)) {
                return true;
            }
            return f.fuelType === _this.fuelType;
        })
            .sort(function (f1, f2) { return f1.price - f2.price; })[0];
        return minFuel ? minFuel.price : null;
    };
    SearchPageComponent.prototype.getMinPriceType = function (index, lowMediumThreshold, mediumHighTreshold) {
        if (index < 0 || lowMediumThreshold == null || mediumHighTreshold == null) {
            return null;
        }
        if (index >= mediumHighTreshold) {
            return 'High';
        }
        else if (index < mediumHighTreshold && index >= lowMediumThreshold) {
            return 'Medium';
        }
        else {
            return 'Low';
        }
    };
    SearchPageComponent.prototype.calculateDeclutterDistance = function (areaDegrees) {
        if (areaDegrees < 15) {
            return 0;
        }
        else if (areaDegrees >= 15 && areaDegrees < 50) {
            return 17;
        }
        else if (areaDegrees >= 50 && areaDegrees < 130) {
            return 22;
        }
        else {
            return 27;
        }
    };
    SearchPageComponent.prototype.declutterMapMarkers = function (airportMarkers, declutterDistance) {
        if (airportMarkers.length < 1) {
            return airportMarkers;
        }
        var toReturn = [];
        var markersTooClose = [];
        var distance = 0;
        for (var i = 0; i < airportMarkers.length; i++) {
            var _loop_1 = function (j) {
                // if marker is already too close to another marker, skip it
                var marker = markersTooClose.find(function (a) { return a.airportId === airportMarkers[j].airportId; });
                if (marker != null) {
                    return "continue";
                }
                // for performance, assume if an airport is not in a neighboring state, it is far enough and we don't have to calc the distance
                if (!this_1.areStatesSameOrNeighbors(airportMarkers[i].stateProvince, airportMarkers[j].stateProvince)) {
                    return "continue";
                }
                distance = airportMarkers[i].location.distanceTo(airportMarkers[j].location) * 0.000621371; // convert meters to miles
                if (distance < declutterDistance) {
                    // if marker is too close add it to the list of too close markers
                    markersTooClose.push(airportMarkers[j]);
                }
            };
            var this_1 = this;
            for (var j = i + 1; j < airportMarkers.length; j++) {
                _loop_1(j);
            }
        }
        // return the original array minus any markers that are too close
        toReturn = airportMarkers.filter(function (a) { return !markersTooClose.map(function (b) { return b.airportId; }).includes(a.airportId); });
        return toReturn;
    };
    SearchPageComponent.prototype.areStatesSameOrNeighbors = function (state1, state2) {
        var toReturn = false;
        if (state1 == null || state2 == null) {
            return toReturn;
        }
        if (state1 === state2) {
            toReturn = true;
            return toReturn;
        }
        var state = this.NEIGHBORSTATES.find(function (s) { return s.code === state1; });
        if (state != null) {
            var neighborStates = state.neighborCodes;
            toReturn = neighborStates.indexOf(state2) !== -1;
            return toReturn;
        }
    };
    SearchPageComponent.prototype.onPublicUseChanged = function () {
        this.searchAirports();
    };
    SearchPageComponent.prototype.onFuelPriceToggleChanged = function () {
        var anyFuelPriceFilterApplied = this.airportResultsListing.airportFilters.fuel100LLFilter.enabled
            || this.airportResultsListing.airportFilters.fuelJetAFilter.enabled
            || this.airportResultsListing.airportFilters.fuelMOGASFilter.enabled
            || this.airportResultsListing.airportFilters.fuelUL94Filter.enabled;
        if (!anyFuelPriceFilterApplied && this.airportResultsListing.showPrices) {
            this._snackBar.open('Please select a fuel type in the Airport Amenities list to display fuel prices', '', {
                duration: 6000
            });
        }
        this.onFiltersChanged();
    };
    SearchPageComponent.prototype.onSelectedActivityChange = function () {
        this.serializeQuery();
        this.searchActivities();
    };
    SearchPageComponent.prototype.onLocationStateChanged = function (state) {
        this.locationState = state;
        if (this.query.type !== SearchFormType.Activities) {
            this.activityState = State.Empty;
        }
        if (state !== State.Content) {
            this.activities = [];
        }
    };
    SearchPageComponent.prototype.onShowAirportsToggleChanged = function () {
        // show or remove pins from display as appropriate
        if (this.eventsResultsListing.showAirports) {
            if (this.exceedsAirportBounds) {
                this.mapMessage = 'Zoom in to update airports displayed';
            }
            this.search(true);
        }
        else {
            // showAirports is false, so call the filter to apply it
            if (this.mapMessage === 'Zoom in to update airports displayed') {
                this.mapMessage = null;
            }
            this.onFiltersChanged();
        }
    };
    /**
     * Initializes the observable that determines when to issue a new search after the map bounds are updated.
     */
    SearchPageComponent.prototype._initBoundsListener = function () {
        var _this = this;
        // Set up the boundsChange$ observable
        this.boundsChange$ = this.map.boundsChange.pipe(
        // Wait until bounds have stabilized before issuing a new search
        debounceTime(SEARCH_DEBOUNCE_TIME), 
        // Avoid issuing a new search when WE programmatically fit the map (after a new search / recenter),
        // but still sync prevBounds to that fitted viewport. Otherwise prevBounds stays stale/null and the
        // first real user pan is either swallowed (used only to initialize prevBounds) or measured against a
        // stale box — so it takes an oversized pan before pan/zoom searches start updating.
        filter(function (b) {
            if (_this.pauseBounds) {
                _this.prevBounds = b;
                return false;
            }
            return true;
        }), 
        // Avoid issuing a new search if this is the first update we received for the map bounds
        filter(function (b) {
            // Record whether we have a previous set of bounds
            var haveBounds = !!_this.prevBounds;
            // If we don't have an initial set of bounds, store the current bounds so we have something to compare to
            // next time around.
            if (!haveBounds) {
                _this.prevBounds = b;
            }
            // Return whether we had prevBounds
            return haveBounds;
        }), 
        // Avoid issuing a search if the viewport bounding box area exceeds MAX_BBOX_AREA (or the wider
        // UNIVERSITY_MAX_BBOX_AREA when searching universities)
        filter(function (b) {
            var area = b.getAreaDegrees();
            var maxArea = _this.query.type === SearchFormType.Universities ? UNIVERSITY_MAX_BBOX_AREA : MAX_BBOX_AREA;
            var exceedsBounds = area > maxArea;
            _this.exceedsAirportBounds = exceedsBounds;
            if (_this.query.type === SearchFormType.AviationEvents) {
                if (_this.eventsResultsListing.showAirports) {
                    _this.mapMessage = exceedsBounds ? 'Zoom in to update airports displayed' : null;
                    return true;
                }
                else {
                    return true;
                }
            }
            _this.mapMessage = exceedsBounds ? 'Zoom in to update results' : null;
            return !exceedsBounds;
        }), 
        // Ensure the new bounding box is sufficiently different from the previous before issuing a search
        filter(function (b) { return !_this.prevBounds || !b.equalTo(_this.prevBounds, _this.getBoundingBoxEpsilon(_this.prevBounds)); }), 
        // Store the new bounding box in prevBounds so we can compare it later
        tap(function (b) { return _this.prevBounds = b; }));
        // Subscribe to the boundsChange$ observable and issue a new search every time it emits an event.
        this.boundsChange$.subscribe(function (b) { return _this.onBoundsChanged(b); });
    };
    SearchPageComponent.prototype.onBoundsChanged = function (bounds) {
        // For a term search, ignore pan/zoom — EXCEPT for events, flying clubs, and flight schools, whose "term"
        // is a location (e.g. a ZIP or city resolved server-side to nearby results, not a name match), so panning
        // should re-query by the new bounds. (An airport term search is a name/ident match and must stay put.)
        if (this.query.term
            && this.query.type !== SearchFormType.AviationEvents
            && this.query.type !== SearchFormType.FlyingClubs
            && this.query.type !== SearchFormType.FlightSchools
            && this.query.type !== SearchFormType.Universities
            && this.query.type !== SearchFormType.Fbos
            && this.query.type !== SearchFormType.ServiceRepair
            && this.query.type !== SearchFormType.RentalSales) {
            return;
        }
        // Update the search query parameters with the new bounding box.
        this.query.location = null;
        this.query.radius = null;
        this.query.bounds = bounds;
        this.serializeQuery();
        // If we're only searching airports, clear out any old activity results.
        if (this.query.type !== SearchFormType.Activities) {
            this.activities = [];
            this.activityState = State.Empty;
        }
        /* if (this.query.type !== SearchFormType.AviationEvents) {
          this.aviationEvents = [];
          this.aviationEventsState = State.Empty;
        } */
        // Perform a new search
        this.search(true);
    };
    SearchPageComponent.prototype.onPageChanged = function (e) {
        this.pageIndex = e.pageIndex;
    };
    SearchPageComponent.prototype.onEventPageChanged = function (e) {
        this.eventPageIndex = e.pageIndex;
    };
    SearchPageComponent.prototype.onFlyingClubPageChanged = function (e) {
        this.flyingClubPageIndex = e.pageIndex;
    };
    SearchPageComponent.prototype.onFlightSchoolPageChanged = function (e) {
        this.flightSchoolPageIndex = e.pageIndex;
    };
    SearchPageComponent.prototype.onUniversityPageChanged = function (e) {
        this.universityPageIndex = e.pageIndex;
    };
    SearchPageComponent.prototype.onFboPageChanged = function (e) {
        this.fboPageIndex = e.pageIndex;
    };
    SearchPageComponent.prototype.onServiceRepairPageChanged = function (e) {
        this.serviceRepairPageIndex = e.pageIndex;
    };
    SearchPageComponent.prototype.onRentalSalesPageChanged = function (e) {
        this.rentalSalesPageIndex = e.pageIndex;
    };
    SearchPageComponent.prototype.updateBackToSearch = function () {
        this.backToSearchVisible = !this.$sidebar['visible'](true);
        this._cdref.detectChanges();
        if (this.backToSearchVisible) {
            this.backToSearchEl.nativeElement.style.top = (window.pageYOffset + 4) + 'px';
            this.backToSearchEl.nativeElement.style.left = (window.pageXOffset + 24) + 'px';
        }
    };
    SearchPageComponent.prototype.backToSearch = function () {
        this.backToSearchVisible = false;
        window.scroll(0, 0);
        this.sidebarOpened = true;
    };
    SearchPageComponent.prototype.onClickNewSearch = function (event) {
        event.preventDefault();
        if (this.selectedTab === this.aviationEventsTab) {
            this._router.navigate(['/'], { queryParams: { 't': 'events' } });
        }
        else if (this.selectedTab === this.flyingClubsTab) {
            this._router.navigate(['/'], { queryParams: { 't': 'flyingclubs' } });
        }
        else if (this.selectedTab === this.flightSchoolsTab) {
            this._router.navigate(['/'], { queryParams: { 't': 'flightschools' } });
        }
        else if (this.selectedTab === this.universitiesTab) {
            this._router.navigate(['/'], { queryParams: { 't': 'universities' } });
        }
        else if (this.selectedTab === this.fbosTab) {
            this._router.navigate(['/'], { queryParams: { 't': 'fbos' } });
        }
        else if (this.selectedTab === this.serviceRepairsTab) {
            this._router.navigate(['/'], { queryParams: { 't': 'servicerepair' } });
        }
        else if (this.selectedTab === this.rentalSalesTab) {
            this._router.navigate(['/'], { queryParams: { 't': 'rentalsales' } });
        }
        else if (this.selectedTab === this.activitiesTab) {
            this._router.navigate(['/'], { queryParams: { 't': 'activities' } });
        }
        else {
            if (this.query && this.query.type && this.query.type === SearchFormType.FuelPrice) {
                this._router.navigate(['/'], { queryParams: { 't': 'fuel' } });
            }
            else {
                this._router.navigate(['/'], { queryParams: { 't': 'airports' } });
            }
        }
    };
    SearchPageComponent.prototype.onError = function (message) {
        this.errorMessage = message;
        if (this.selectedTab === this.airportsTab) {
            this.airportState = State.Error;
        }
        else {
            this.activityState = State.Error;
        }
    };
    return SearchPageComponent;
}());
export { SearchPageComponent };
